import { LOCALES } from '../locales';
const getCommonMessages = () => ({
  adminDepsTitle: 'Admin — Vérification des registres de données',
  adminDepsSubtitle:
    "Vérifie que chaque registre de données aiWARE dont Redact dépend existe et possède un schéma publié, du point de vue de l'utilisateur connecté. À utiliser comme test de fumée après l'installation ou la mise à niveau d'un environnement.",
  adminDepsRerun: 'Relancer',
  adminDepsCopyReport: 'Copier le rapport',
  adminDepsCopied: 'Copié',
  adminDepsRunning: 'Vérification des registres de données…',
  adminDepsAllPass: 'Tous les registres de données requis sont installés.',
  adminDepsSomeFail:
    '{count, plural, one {# registre de données est manquant ou mal configuré} other {# registres de données sont manquants ou mal configurés}}.',
  adminDepsColStatus: 'Statut',
  adminDepsColFeature: 'Utilisé pour',
  adminDepsColConfigKey: 'Clé de configuration',
  adminDepsColId: 'ID du registre / schéma',
  adminDepsColRegistry: 'Nom du registre',
  adminDepsColSchema: 'Schéma publié',
  adminDepsColNotes: 'Remarques',
  adminDepsStatusPending: 'Vérification',
  adminDepsStatusPass: 'Réussi',
  adminDepsStatusSkipped: 'Ignoré',
  adminDepsStatusMissingConfig: 'Configuration manquante',
  adminDepsStatusNotFound: 'Introuvable',
  adminDepsStatusNoPublishedSchema: 'Aucun schéma publié',
  adminDepsStatusError: 'Erreur',
  adminDepsSkippedDetail: 'Désactivé par {flag}',
  adminDepsUsingDefault:
    "Clé de configuration absente ; utilisation de l'ID par défaut intégré à l'application",
  adminDepsUsingFallbackKey:
    'Clé de configuration absente ; utilisation de son ancienne clé de repli',
  adminDepsTdoRedactState: 'État de caviardage des fichiers',
  adminDepsNotifications: 'Notifications',
  adminDepsCases: 'Dossiers',
  adminDepsAuditLog: 'Journal d’audit',
  adminDepsMediaComments: 'Commentaires sur les médias',
  adminDepsDocumentComments: 'Commentaires sur les documents',
  adminDepsRedactionStatuses: 'Statuts de caviardage',
  adminDepsRedactionStatusesPinned: 'Statuts de caviardage (schéma épinglé)',
  adminDepsRedactionCodes: 'Codes de caviardage',
  adminDepsTdoLock: 'Verrouillage des fichiers',
  adminDepsSettingsProfiles: 'Profils de paramètres',
  adminDepsLexicons: 'Lexiques',
  adminDepsWatermarks: 'Filigranes',
  adminDepsStatusHistory: 'Historique des statuts',
  adminDepsNotInSchemasPackage:
    'Non installé par le paquet Redact Schemas ; doit être installé séparément',
  schemaIdNotFound:
    'SchemaId introuvable. Veuillez vérifier le fichier de configuration du système.',
  review: 'Examen',
  correction: 'Correction',
  uploadMedia: 'Télécharger des Médias',
  sortBy: 'Trier par',
  createdDate: 'Date de Création',
  lastModifiedDate: 'Date de la dernière modification',
  draft: 'Brouillon',
  toDo: 'À faire',
  pendingReview: "En attendant l'examen",
  correctionNeeded: 'Correction requise',
  complete: 'Complet',
  results: 'Résultats',
  redactedFiles: 'Fichiers Caviardés',
  save: 'Enregistrer',
  redactFile: 'Caviarder',
  // trimAndRedact: 'Découper & Caviarder',
  trimAndRedact: 'Trim & Caviarder', // causing layout issue - this is temp fix
  trimOnly: 'Découper seulement',
  setTrimRange: 'Régler la intervalle de découpage',
  clearTrimRange: 'Nettoyer la intervalle de découpage',
  none: 'Aucun',
  voice_mask: 'Masque Vocal',
  black_fill: 'Remplissage noir',
  outline: 'Esquisser',
  redacted: 'Caviardés',
  redacting: 'Caviardant',
  refresh: 'Actualiser',
  refreshing: 'Actualisation…',
  ingesting: 'Ingérant',
  preview: 'Prévisualiser',
  tools: 'Outils',
  collapseToolPanel: 'Masquer le nom des outils',
  expandToolPanel: 'Afficher le nom des outils',
  videoPreview: 'Vidéo Prévisualiser',
  imagePreview: 'Image Prévisualiser',
  audioPreview: 'Audio Prévisualiser',
  // 'Détecter des Objets' overflowed the button — FR uses the short form at
  // every panel width (same wording as the `detect` key below)
  detectObjects: 'Détecter',
  detect: 'Détecter',
  restoreOriginalResults: 'Restaurer les détections originales',
  deleteResults: 'Supprimer les détections',
  restoreConfirmation: 'Restaurer la confirmation',
  restoreConfirmationDes:
    "Êtes-vous sûr de vouloir restaurer les résultats originaux de la détection d'objets ?",
  deleteConfirmation: 'Confirmation de suppression',
  deleteConfirmationDes:
    "Êtes-vous sûr de vouloir supprimer les résultats actuels de la détection d'objets ?",
  runAgain: 'Détecter à nouveau les objets',
  detectDescription:
    'Détectez et placez automatiquement des boîtes de délimitation sur les objets dans cette {mediaType, select, image {image} video {vidéo} other {média}}, ce qui rend la rédaction plus rapide et plus facile pour vous.',
  detectEmptyDescription: "Aucune aucun objet n'a été détecté dans ce média.",
  detectDeletedDescription: 'Tous les objets détectés ont été supprimés.',
  objectDetection: "Détection d'Objets",
  tracking: 'Suivi',
  noPersonOfInterestImages: "AUCUNE IMAGE DE PERSONNE D'INTÉRÊT",
  POIReferenceImages: 'POI Images',
  images: 'POI Images',
  image: 'Image',
  video: 'Vidéo',
  audio: 'Audio',
  other: 'Autre',
  comments: 'Commentaires',
  somethingWrong: 'Quelque Chose a Mal Tourné',
  home: 'Domicile',
  transcription: 'Transcription',
  errorTranscriptionRun:
    "Une erreur s'est produite lors de l'exécution du moteur de transcription. Voulez-vous réexécuter le moteur ?",
  errorObjectDetectionRun:
    "Une erreur s'est produite lors de l'exécution du moteur de détection d'objets. Voulez-vous réexécuter le moteur ?",
  transcribeAudio: "Transcrire l'Audio",
  transcribeAudioAndRunVoiceMask:
    "Transcrire l'Audio & Exécuter le Masque Vocal",
  transcriptionMessage:
    "Transcrivez automatiquement ce média pour caviarder commodément toute partie de l'audio.",
  transcriptionAndRunVoiceMaskMessage:
    'Transcrivez automatiquement ce média activez les fonctionnalités de masquage vocal.',
  generateVoiceMask: 'Générer le Masque Vocal',
  generateVoiceMaskMessage:
    "La génération du masque vocal sera traitée en arrière-plan. Cela prendra plusieurs minutes selon la durée de votre média. Si vous prévoyez de le faire à l'avenir, vous pouvez aussi exécuter le masquage vocal lors du téléversement du média.",
  noTranscribableAudio:
    "Aucun enregistrement audio transcriptible n'a été trouvé dans ce média.",
  deleteReactionTitle: 'Dupprimer le dernier fichier caviardé',
  deleteReactionContent: 'Voulez-vous supprimer le dernier fichier caviardé ?',
  previousVersions: 'Il reste {numVersions} version(s) précédente(s).',
  exitWithoutSaving: 'Quitter sans enregistrer',
  delete: 'Supprimer',
  remove: 'Supprimer',
  move: 'Déplacer',
  fileDetails: 'Détails du fichier',
  version: 'Version',
  resolution: 'Résolution',
  fileSize: 'Taille du fichier',
  redactionMetrics: 'Métriques de caviardage',
  processingNewerRedactedVersion:
    'Traitement de la version caviardée {version}… La page sera mise à jour lorsqu’elle sera prête.',
  // VE-25870 stale-redacted-file safeguard
  staleRedactedFileBanner:
    'Le fichier caviardé n’inclut pas les modifications les plus récentes. Cliquez sur le bouton Caviarder le fichier pour créer un fichier de sortie à jour.',
  staleRedactedFileShortBanner:
    'Le fichier caviardé n’inclut pas les modifications les plus récentes.',
  staleVersionWarningTitle: 'Avertissement de version',
  staleRedactedFileUnsavedBanner:
    'Le fichier caviardé n’inclut pas les modifications non enregistrées les plus récentes.',
  staleVersionWarningUnsaved:
    'La version {version} du fichier caviardé n’inclut pas les modifications non enregistrées actuelles!',
  staleVersionWarningUnsavedNoVersion:
    'Le fichier caviardé n’inclut pas les modifications non enregistrées actuelles!',
  staleVersionWarningStale:
    'La version {version} du fichier caviardé n’inclut pas les modifications de caviardage les plus récentes!',
  staleVersionWarningStaleNoVersion:
    'Le fichier caviardé n’inclut pas les modifications de caviardage les plus récentes!',
  staleVersionWarningInProgress:
    'Le traitement de la version caviardée {version} est en cours! Vous êtes sur le point de télécharger la version précédente.',
  staleVersionWarningInProgressNoVersion:
    'Le traitement d’un fichier caviardé est en cours! Vous êtes sur le point de télécharger la version précédente.',
  sendAnyways: 'Envoyer quand même',
  downloadAnyways: 'Télécharger quand même',
  staleReasonMissingLatestEdits:
    'Modifications de caviardage les plus récentes manquantes',
  staleReasonNewerVersionInProgress: 'Traitement de la version {version}',
  downloadReviewTitle: 'Révision du téléchargement',
  downloadReviewIncludeRedactedMedia: 'Fichiers caviardés',
  downloadReviewIncludeAuditLogs: 'Journal d’audit',
  downloadReviewIncludeTranscripts: 'Transcription caviardée',
  downloadReviewIncludeUnfinished:
    'Inclure les fichiers non marqués comme complets',
  downloadReviewOptionsHeading: 'Options de téléchargement',
  downloadReviewStaleWarning:
    'Certains fichiers ne comportent pas les plus récentes modifications de caviardage! Ils ont été désélectionnés.',
  downloadReviewProcessingWarning:
    'Certains fichiers sont encore en cours de traitement de la plus récente version caviardée. Ils ont été désélectionnés.',
  downloadReviewStaleOrProcessingWarning:
    'Certains fichiers ne comportent pas les plus récentes modifications de caviardage ou sont en cours de traitement d’une nouvelle version! Ils ont été désélectionnés.',
  downloadReviewIncompleteWarning:
    'Certains fichiers ne sont pas marqués comme complets.',
  downloadReviewColumnName: 'Fichier',
  downloadReviewColumnStatus: 'Statut de caviardage',
  downloadReviewColumnSize: 'Taille du fichier',
  downloadReviewColumnCreated: 'Fichier caviardé créé le',
  downloadReviewColumnWarning: 'Avertissement',
  downloadReviewIncompleteStatus: 'Le fichier n’est pas marqué comme complet',
  downloadReviewSelectedCount: '{selected} fichiers sur {total} sélectionnés',
  downloadReviewDestinationHint:
    'Vous choisirez le dossier de destination après avoir cliqué sur Télécharger.',
  imageSizeTrueSize: 'Taille réelle',
  imageSizeAutoFit: 'Ajustement automatique',
  downloadsSection: 'Téléchargements',
  additionalDownloadsSection: 'Téléchargements supplémentaires',
  sendToSection: 'Envoyer à',
  manageSection: 'Gérer',
  download: 'Télécharger',
  defaultSize: 'Taille par défaut',
  defaultSizeHint: '100 % correspond à toute la largeur de la page.',
  defaultOpacity: 'Opacité par défaut',
  defaultGrayscaleHint: "Supprimer la couleur de l'image par défaut",
  watermarkDefaultsPreview: 'Aperçu',
  watermarkDefaultsPreviewEmpty: "Ajoutez du texte ou une image pour l'aperçu",
  downloadZip: 'Télécharger ZIP',
  downloadAll: 'Télécharger Tout',
  exportZip: 'Exporter ZIP',
  exportZipWarning:
    "Le fichier zip comprend à la fois les médias caviardés et le journal d'audit. Attention : l'exportation vers un fichier zip est plus lente que le téléchargement direct de les médias caviardés ou le journal d'audit !",
  downloadAllMessage: "Téléchargera les médias expurgés et le journal d'audit.",
  downloadAllFiles: 'Tous les fichiers',
  downloadMedia: 'Média caviardé',
  downloadAuditLog: "Journal d'audit",
  downloadRedactedTranscript: 'Transcription caviardée',
  downloadRedactionReport: 'Télécharger le rapport de caviardage',
  sendToGovQa: 'Envoyer à GovQa',
  sendToFOIAXpress: 'Envoyer à le FOIAXpress',
  sendToCasepoint: 'Envoyer à le Casepoint',
  sendToExterro: 'Envoyer à le Exterro Review',
  sendToNuix: 'Envoyer à le Nuix Discover',
  sendToExternal: 'Envoyer à le Exterro',
  GovQAAuthentication: 'Authentification de le GovQA',
  add: 'Ajouter',
  cancel: 'Annuler',
  confirm: 'Confirmer',
  ok: 'Ok',
  mute: 'Muet',
  tone: 'Tonalité•e',
  blur: 'Flou',
  blackfill: 'Remplissage noir',

  headShape: 'Tête Forme',
  udrShape: 'UDR Forme',
  laptopShape: 'Ordinateur Forme',
  vehicleShape: 'Véhicule Forme',
  licensePlateShape: 'Plaque Forme',
  cardShape: "Carte d'identité (PII) Forme",
  notepadShape: 'Bloc-notes (PII) Forme',
  personShape: 'Personne Forme',

  headRedaction: 'Tête Caviardée',
  udrRedaction: 'UDR Caviardé',
  laptopRedaction: 'Ordinateur Caviardé',
  vehicleRedaction: 'Véhicule Caviardé',
  licensePlateRedaction: 'Plaque Caviardée',
  cardRedaction: "Carte d'identité (PII) Caviardée",
  notepadRedaction: 'Bloc-notes (PII) Caviardée',
  personRedaction: 'Personne Caviardée',

  shapesAndScaling: 'Formes et échelles',
  shape: 'Forme',
  shapes: 'Formes',
  defaultShape: 'Défaut ({currentShape})',
  rectangle: 'Rectangle',
  ellipse: 'Ellipse',

  featherTypeHead: 'Tête Type de plume (flou)',
  featherTypeUdr: 'UDR Type de plume (flou)',
  featherTypeLaptop: 'Ordinateur Type de plume (flou)',
  featherTypeVehicle: 'Véhicule Type de plume (flou)',
  featherTypeLicensePlate: 'Plaque Type de plume (flou)',
  light: 'Léger',
  medium: 'Moyen',
  heavy: 'Lourd',
  beforeMs: 'Avant (ms)',
  afterMs: 'Après (ms)',

  settings: 'Réglages',
  videoType: 'Type de vidéo',
  confidenceThreshold: 'Seuil de Confiance',
  legacyClustering: 'Groupement hérité',
  clusterSimThreshold: 'Seuil de similarité des grappes',
  verylowThreshold: 'Très faible (moins de groupes)',
  lowThreshold: 'Faible',
  mediumThreshold: 'Moyen',
  highThreshold: 'Elevé',
  veryhighThreshold: 'Très élevé (plus de groupes)',
  accuracySpeed: 'Précision ↔ Vitesse',
  trackBackwardsLimit: 'Suivre la limite arrière',
  seconds: 'secondes',
  trackForwardLimit: 'Suivre la limite avant',
  autoInterpolation: 'Interpolation automatique',
  milliseconds: 'millisecondes',
  millisecondsNote: 'millisecondes ({value})',
  manualInterpolationWindow: "Fenêtre d'interpolation manuelle",
  manualInterpolationNote: 'millisecondes ({value} ; 0 = désactivée)',
  videoOffset: 'Décalage vidéo',
  fillType: 'Remplir',
  redactionType: 'Type de caviardage',
  detectionType: 'Type de détection',

  blurLevel: 'Niveau de flou',
  aTob: '{a} à {b}',
  allWorkWillBeReset: 'Tout le travail sera remis à zéro',
  blurLevelVehicle: 'Niveau de flou (Véhicule)',
  patchPreviousVersion: 'Corriger la version précédente',
  showNonRedactedOverlaysWhileEditing:
    "Afficher les superpositions non caviardées (pendant l'édition)",
  saveChanges: 'Enregistrer les changements',
  saveContentModal:
    'Voulez-vous enregistrer vos modifications avant de fermer ?',
  saveRunning: 'Enregistrement en course',
  saveRunningContentModal:
    "Êtes-vous sûr de vouloir quitter avant la fin de l'enregistrement ?",
  saveFailed: "Échec de l'enregistrement !",
  saveFailedContentModal:
    "L'enregistrement des modifications a échoué. Voulez-vous réessayer ?",
  saveBeforeStatusLockFailed: 'Impossible de changer le statut !',
  redactFileSaveFailed:
    'Impossible d’enregistrer vos caviardages; le fichier n’a pas été envoyé au caviardage. Veuillez réessayer.',
  lockStatusMediaNotReady:
    'Impossible de mettre à jour le statut : veuillez attendre que les caviardages finissent de charger.',
  request: 'Demande',
  notifications: 'Notifications',
  newNotifications: 'Nouvelles Notifications',
  dismissedNotifications: 'Notifications Rejetées',
  dismissAll: 'Rejeter Tout',
  clearAll: 'Effacer Tout',
  keyboardShortcuts: 'Raccourcis clavier',
  openInNewWindow: 'Ouvrir dans une nouvelle fenêtre',
  general: 'Général',
  redactMedia: 'Caviarder les médias',
  trackObject: "Suivre l'objet",
  trackForwardOnly: 'Piste en avant seulement',
  trackBackwardOnly: 'Piste en arrière seulement',
  zoomInTimeline: 'Zoom la chronologie',
  zoomOutTimeline: 'Zoom arrière chronologie',
  toggleUdrTimeline: 'Basculer la chronologie UDR',
  warningAssignMergedGroup:
    'Attention ! Le groupe est assigné à un groupe fusionné !',
  addCustomFill: 'Ajouter des effets personnalisés',
  removeCustomFill: 'Supprimer les effets personnalisés',
  removeCustomFillCount: 'Retirer Effets Personnalisés ({count})',
  restoreRedactionConfiguration: "Restaurer l'effet de rédaction",
  addEditRedactionConfigurationContent:
    "Vous êtes sur le point d'ajouter/modifier un effet de censure. Appliquer les modifications à",
  restoreRedactionConfigurationContent:
    'Vous êtes sur le point de restaurer un effet de rédaction. Appliquer le changement à',
  // editRedactionConfiguration: 'Modifier les effets personnalisés',
  // removeRedactionConfiguration: 'Supprimer les effets personnalisés',
  customEffects: 'Effets personnalisés',
  noEffects: 'Aucun Effet',
  mixedEffects: 'Effets Mixtes',
  removeRedactionConfigurationContent:
    'Vous êtes sur le point de supprimer la configuration des effets personnalisés. Etes-vous sûr?',
  removeRedactionConfigurationContentMergedGroup:
    "Vous êtes sur le point de supprimer l'effet de rédaction personnalisé. Appliquer les modifications à",
  redactionEffects: 'Effets de rédaction',
  bulkEffects: 'effets de masse',
  bulk: 'en gros',
  objectType: "Type d'objet",
  restoreDefault: 'Rétablir Défaut',
  redactionConfiguration: 'Configuration du caviardage',
  addRedactionCode: 'Ajouter un code de caviardage',
  editRedactionCode: 'Modifier un code de caviardage',
  addEditRedactionCodeContent:
    "Vous êtes sur le point d'ajouter/modifier un code de censure. Appliquer les modifications à",
  removeRedactionCode: 'Suppression un code de caviardage',
  removeRedactionCodeContent:
    'Vous êtes sur le point de supprimer le code de caviardage. Vous êtes sûr ?',
  removeRedactionCodeContentMergedGroup:
    'Vous êtes sur le point de supprimer le code de rédaction. Appliquer les modifications à',
  addCode: 'Ajouter un code',
  editCode: 'Modifier le code',
  chooseColorLabel: 'sélectionnez votre couleur',
  chooseCodeLabel: 'Choisissez le nom du code de caviardage',
  changeShape: 'Modifier la forme',
  changeShapeContent:
    'Vous êtes sur le point de modifier le type de forme. Appliquer le changement à',
  center: 'Centre',
  top: 'Haus',
  bottom: 'Bas',
  above: 'Au-dessus de',
  below: 'En dessous de',
  left: 'Gauche',
  right: 'Droite',
  addRedactionCodeLocationPlaceholder: '- Sélectionner la Position -',
  restoreDefaultColor: 'Restaurer la Couleur par Défaut',
  stickToVideo: 'Coller à la vidéo',
  setTimeStamp: "Définir l'horodateur",
  minVal: 'Valeur minimale: {value}',
  maxVal: 'Valeur maximale: {value}',
  errorExceededName: 'Valeur maximale : dépassé',
  errorExceededType: 'dépassé',
  errorStartAfterEndName: 'Le début ne peut pas suivre la fin',
  errorStartAfterEndType: 'Invalide',
  manualTrackingLocked: 'Suivi manuel (Verrouillé)',
  redactUnredactHighlightedGroup: 'Rédiger/Dérédiger le groupe surligné',
  redactUnredactHighlightedSegment: 'Rédiger/Dérédiger le segment surligné',
  redactGroupFromOverlay: 'Rédiger le groupe (depuis la superposition)',
  startTrackingFromOverlay: 'Commencer le suivi (depuis la superposition)',
  increaseRectSize: 'Augmenter la taille du rectangle',
  decreaseRectSize: 'Diminuer la taille du rectangle',
  increaseUDRSizeHorizontally: 'Augmenter la taille de l`UDR horizontalement',
  decreaseUDRSizeHorizontally: 'Diminuer la taille de l`UDR horizontalement',
  undoRedoUnavailableWhileTracking:
    'Annuler / Rétablir (indisponible pendant le suivi)',
  increaseUDRSizeVertically: 'Augmenter la taille de l`UDR verticalement',
  decreaseUDRSizeVertically: 'Diminuer la taille de l`UDR verticalement',
  playback: 'Relecture',
  playPause: 'Jouer/Pause',
  spaceBar: "barre d'espace",
  goBackFrame: 'Revenir en arrière',
  or: 'ou',
  pushToPlayReverse: 'Pousser-pour-jouer (inverse)',
  pushToPlay: 'Pousser-pour-jouer',
  holdDown: 'Prise',
  advanceFrame: 'Avancer un cadre',
  start: 'Le Début',
  end: 'La Fin',
  jumpOneSecond: "Saut d'une seconde",
  jump10Seconds: 'Saut de 10 secondes',
  jumpOneMinute: "Saut d'une minute",
  jumpToStart: 'Aller au début',
  jumpToEnd: 'Aller à la fin',
  increasePlaybackSpeed: 'Augmenter la vitesse de lecture',
  decreasePlaybackSpeed: 'Réduire la vitesse de lecture',
  defaultPlaybackSpeed: 'Vitesse de lecture par défaut',
  returnToPreviousMarker: 'Retour au marqueur précédent',
  setMarkerToCurrent: 'Fixer le marqueur à la position actuelle',
  setToMaxValue: 'Utilisez le maximum',
  setToMinValue: 'Utiliser le minimum',
  currentTime: 'Heure actuelle',
  editor: 'Éditeur',
  viewOnly: 'Lecture seule',
  deleteUDR: 'Supprimer UDR',
  deleteOverlay: 'Supprimer la superposition',
  deleteGroup: 'Supprimer le group',
  deleteGroupContent:
    'Vous êtes sur le point de supprimer le groupe. Appliquer le changement à',
  deleteGroupFailure: 'Échec de la suppression du groupe.',
  deleteInFrame: 'Supprimer dans le cadre',
  deleteLabel: 'Supprimer {label}',
  deleteLabelInFrame: 'Supprimer {label} dans le cadre',
  deleteLabelOverlay: 'Supprimer la superposition {label}',
  deleteLabelSegment: 'Supprimer le segment {label}',
  deleteLabelGroup: 'Supprimer le group {label}',
  deleteOriginalGroup: "Supprimer le group d'origine",
  deleteMergedGroup: 'Supprimer groupe fusionné',
  unRedactInFrame: 'Non censuré {label} dans le cadre',
  unRedactOverlay: 'Non censuré la superposition {label}',
  unRedactSegment: 'Non censuré le segment {label}',
  unRedactGroup: 'Non censuré le group {label}',
  unRedactOriginalGroup: "Non censuré le group d'origine",
  unRedactMergedGroup: 'Non censuré groupe fusionné',
  unRedactLabelSegment: 'Non censuré le segment {label}',
  redactLabelSegment: 'Caviarder le segment {label}',
  redactOriginalGroup: "Caviarder le groupe d'origine",
  redactLabelGroup: 'Caviarder le groupe {label}',
  resizeLabelSegment: 'Redimensionner le segment {label}',
  resize: 'Redimensionner',
  resizeScalingGlobal: "Augmenter l'échelle",
  changePreview: "Modifier l'aperçu",
  selectNextOverlay: 'Parcourir la Superposition Surlignée',
  jumpNextGroupSegment: 'Aller à la segment suivant',
  IncreaseUDRSize: "Augmenter la taille de l'UDR",
  selectDeselectGroup: 'Rédiger/Dérédiger le Groupe',
  decreaseUDRSize: "Diminuer la taille de l'UDR",
  addTextTool: 'Ajouter du texte (maintenir)',
  close: 'Fermer',
  // VE-26730: status-change history + correction notes
  statusHistoryNoteModalTitle: 'Ajouter une note de correction',
  statusHistoryNoteModalTitleBulk:
    'Ajouter une note de correction pour {count} fichiers',
  statusHistoryNoteFieldLabel: 'Note (facultative)',
  statusHistoryNoteModalConfirm: 'Appliquer le statut',
  statusHistoryButtonTooltip: 'Historique des statuts',
  statusHistoryButtonTooltipWithNote:
    'Historique des statuts — contient une note',
  statusHistoryModalTitle: 'Historique des statuts',
  statusHistoryModalTitleNote: 'Note de correction',
  statusHistoryModalNoteHelp:
    'Ce fichier a été retourné pour correction. Veuillez traiter la note ci-dessous. Une fois terminé, nous recommandons de le faire passer à un statut approprié.',
  statusHistoryColumnNote: 'Note ajoutée',
  statusHistoryAutomaticTag: 'Automatique',
  statusHistoryCurrentStatus: 'Statut actuel',
  statusHistoryLocksEditing: 'Ce statut verrouille les modifications',
  statusHistoryEmpty:
    'Aucun historique de statut pour ce fichier pour le moment.',
  statusHistoryEmptyCurrent: 'Statut actuel :',
  statusHistoryEmptyUnrecorded:
    'Les changements antérieurs sont antérieurs à la fonction d’historique des statuts. Ils se trouvent dans le journal d’audit du fichier.',
  statusHistoryPartial:
    'Ce fichier avait déjà un statut lorsque Redact l’a vu pour la première fois. Les changements antérieurs n’ont pas été enregistrés.',
  statusHistoryUnknownDepth:
    'Les changements de statut antérieurs à ce point sont antérieurs à la fonction d’historique des statuts. Ils se trouvent dans le journal d’audit du fichier.',
  statusHistoryError: "Impossible de charger l'historique des statuts.",
  statusHistoryLoadMore: 'Afficher plus',
  statusHistoryViewFull: 'Afficher l’historique complet des statuts',
  statusHistoryHideFull: 'Masquer l’historique',
  statusHistoryClear: 'Effacer l’historique',
  statusHistoryClearConfirmTitle: 'Effacer l’historique des statuts',
  statusHistoryClearConfirmBody:
    'Cela effacera l’historique des statuts. Voulez-vous continuer ?',
  statusHistoryClearConfirm: 'Effacer l’historique',
  statusHistoryClearedMarker:
    'Les changements de statut avant le {date} ont été effacés par {user}.',
  statusHistoryNoteShowMore: 'Afficher plus',
  statusHistoryNoteShowLess: 'Afficher moins',
  statusHistoryResponseModalTitle: 'Confirmer que cette note a été traitée',
  statusHistoryResponseFieldLabel: 'Réponse (facultative)',
  statusHistoryResponseModalConfirm: 'Oui — traitée',
  statusHistoryResponseModalSkip: 'Ignorer',
  statusHistoryResponseModalNo: 'Non',
  statusHistoryOutcomeAddressed: 'Note traitée',
  statusHistoryOutcomeNotAddressed: 'Note non traitée',
  statusHistoryOutcomeSkipped: 'Note ignorée',
  statusHistoryResponseLabel: 'Réponse',
  statusHistoryBulkNoteTitle: 'Certains fichiers ont des notes non traitées',
  statusHistoryBulkNoteBody:
    '{count} des {total} fichiers sélectionnés sont en « Correction requise » avec une note non traitée.',
  statusHistoryBulkNoteSkip: 'Les ignorer — appliquer à {count}',
  statusHistoryBulkNoteProceed: 'Appliquer aux {count}',
  reRunEngine: 'REDIFFUSION LE MOTEUR',
  continue: 'Continuer',
  DetectHeadsandObjects: 'Détecter Les Têtes et Les Objets',
  DetectHeadsandObjectsDes:
    "L'exécution de la détection de la tête et des objets remplacera tous les résultats précédents de la détection de la tête et des objets. Souhaitez-vous continuer ?",
  detectObjectsTitle: 'Détecter des objets',
  // 'Effets de remplissage' overflowed the button — FR uses the short form at
  // every panel width (same wording as the `fill` key below)
  fillEffects: 'Remplir',
  fill: 'Remplir',
  shapeEffects: 'Effets de forme',
  resizeRightPanel: 'Redimensionner le panneau droite',
  hideRightPanel: 'Masquer le panneau droite',
  openRightPanel: 'Ouvrir le panneau droit',
  expandVideo: 'Agrandir la vidéo',
  shrinkVideo: 'Réduire la vidéo',
  // previewOptions: 'Options de prévisualisation', // TOO LONG
  previewOptions: 'prévisualisation',
  // hidePreviewOptions: 'Options de prévisualisation cachées', // TOO LONG
  hidePreviewOptions: 'prévisualisation cachées',
  fillEffectsTip:
    'Mettre à jour les effets de remplissage par défaut pour la rédaction',
  shapeEffectsTip:
    "Mettre à jour les effets de forme et d'échelle par défaut pour la rédaction",
  shapeAndScalingEffects: "Effets de forme et d'échelle",
  detectHeadObjectsDes:
    'Cela remplacera les résultats de détection actuels. Voulez-vous continuer ?',
  detectHeadObjectSelectTitle: "Types d'objets",
  detectObjectTypesRequiredHint: 'Au moins une option doit être sélectionnée',
  object: 'Objet',
  auto: 'Auto',
  time: 'Temps',
  coordinates: 'Coordonnées',
  segmentType: 'Taper',
  manual: 'Manuel',
  interpolation: 'INTERPOLATION',
  saveChangesMessage: 'Voulez-vous enregistrer les modifications ?',
  selectedObjectProcessing: "L'objet sélectionné est en cours de traitement",
  ConfirmUnlinkingModalTitle: 'Confirmer le délien du CMS',
  ConfirmUnlinkingModalContent:
    'Vous êtes sur le point de délier les fichiers {tdoCount} du CMS. Vos ressources multimédia seront toujours présentes dans le CMS mais vous ne pourrez plus y accéder dans Redact.',
  unlink: 'Délier',
  uploadFailed: 'le téléchargement a échoué',
  processingNewMedia: 'Traitement des nouveaux médias...',
  newlyAddedBadge: 'Nouveau',
  lastOpenedBadge: 'Dernier ouvert',
  recentlyOpened: 'Récemment ouvert',
  gridView: 'Vue en grille',
  detailsView: 'Vue détaillée',
  classicView: 'Vue classique',
  showPanel: 'Afficher le panneau de navigation',
  organize: 'Organiser',
  organizeDragDropHint:
    'Pour organiser, glissez-déposez les fichiers dans les demandes.',
  hidePanel: 'Masquer le panneau',
  sortStatus: 'Statut',
  sortStatusReverse: 'Statut (inverse)',
  sortRedactedFirst: "Caviardés d'abord",
  sortOriginalFirst: "Originaux d'abord",
  modifiedOldest: 'Modification la plus ancienne',
  engines: 'Moteurs',
  modified: 'Modifié',
  closeRequestView: 'Fermer la requête et afficher les colonnes',
  resizeNameColumn:
    'Faire glisser pour redimensionner — double-cliquer pour ajuster aux noms',
  noFilesMatchFilters: 'Aucun fichier ne correspond aux filtres actuels!',
  reqID: 'Req ID',
  fileRedacted: 'Fichier caviardé',
  redactingFile: 'Le fichier est en cours de caviarder',
  playVideo: 'Lire la vidéo',
  noFiles: 'Aucun fichier',
  noFilesUploaded: 'Aucun fichier téléchargé',
  uploadFilesToStarted: 'Téléchargez vos fichiers pour commencer',
  uploadFile: 'Télécharger le fichier',
  noResultsFound: 'Aucun résultat trouvé',
  notFoundDes: 'Veuillez essayer une autre sélection.',
  confirmDeletionModalTitle: 'Confirmer la suppression',
  confirmDeletionModalContent:
    "Vous êtes sur le point de supprimer les fichiers {tdoCount}. Vous ne serez pas en mesure d'annuler cette action.",
  timeUntilDeletionLessThanHour: '< 1 heure',
  timeUntilDeletionHours: '{hours, plural, one {# heure} other {# heures}}',
  timeUntilDeletionDays: '{days, plural, one {# jour} other {# jours}}',
  timeUntilDeletionDaysHours: '{daysPart}, {hoursPart}',
  confirmMoveToTrashModalTitle: 'Confirmer le déplacement vers la corbeille',
  confirmMoveToTrashModalContent:
    'Vous êtes sur le point de déplacer {tdoCount} fichiers vers la corbeille. Vous pourrez les restaurer depuis la page Corbeille.',
  confirmMultiDeletionModalTitle: 'Suppression de plusieurs fichiers',
  confirmMultiDeletionModalContent:
    'Vous êtes sur le point de supprimer les fichiers {tdoCount}. Vous êtes sûr ?',
  confirmMultiMoveToTrashModalTitle:
    'Déplacer plusieurs fichiers vers la corbeille',
  confirmMultiMoveToTrashModalContent:
    'Vous êtes sur le point de déplacer {tdoCount} fichiers vers la corbeille. Voulez-vous continuer ?',
  filePickerRunHeadTooltip:
    "Détecter des têtes, des ordinateurs et des plaques d'immatriculation",
  filePickerRunPersonTooltip:
    "Détecter des personnes, des ordinateurs et des plaques d'immatriculation",
  filePickerRunHead: 'Détecter des têtes et des objets',
  filePickerRunPerson: 'Détecter des personnes et des objets',
  runTranscription: 'Exécuter la transcription',
  runVoiceMask: 'Exécuter le Masque Vocal',
  removeExistingAudioRedactions: 'Supprimer tous les caviardages audio',
  runPII: "Exécuter la détection d'IIP",
  runOCR: 'Exécuter la détection ROC',
  runOCRTooltip:
    "Exécuter la reconnaissance optique de caractères (ROC) sur les pages numérisées pour activer la recherche et la détection d'IIP.",
  filePickerGroupMedia: 'Médias',
  filePickerGroupDocuments: 'Documents',
  filePickerUploadLimitExceededDocuments:
    'Maximum de {limit} documents dépassé. Retirez-en {excess} pour continuer.',
  filePickerUploadLimitExceededMedia:
    'Maximum de {limit} fichiers image/audio/vidéo dépassé. Retirez-en {excess} pour continuer.',
  selectLexicons: 'Sélectionner des lexiques',
  autoRedact: 'Caviardage auto',
  autoRedactSearching: 'Recherche de caviardages automatiques du lexique',
  autoRedactSearchingBody:
    'Les correspondances seront caviardées automatiquement à la fin de la recherche.',
  autoRedactDoneTitle: 'Caviardages automatiques appliqués',
  autoRedactDoneBody:
    '{count, plural, one {# caviardage a} other {# caviardages ont}} été appliqué automatiquement à partir des correspondances du lexique.',
  autoRedactRemove: 'Retirer le caviardage auto',
  autoRedactHint:
    'Marquer automatiquement toutes les correspondances du lexique pour caviardage. Sinon, elles peuvent être examinées et ajoutées depuis l’onglet des résultats de détection.',
  runLexiconDetection: 'Exécuter la détection de lexique',
  voiceMaskEnabled: 'Masque Vocal: activé',
  ingest: 'Ingérer',
  ingestFromUrl: "Ingérer depuis l'URL",
  ingestUrlPlaceholder: 'Coller une URL à ingérer',
  ingestUrlClear: "Effacer l'URL",
  ingestUrlEdit: "Modifier l'URL",
  ingestUrlConfirm: "Confirmer l'URL",
  govqaID: 'ID de la demande GovQA : {govQARequestId}',
  foiaXpressID: 'ID de la demande FOIAXpress : {foiaXpressRequestId}',
  casepointID: 'Casepoint ID : {casepointRequestId}',
  nuixID: 'NUIX ID : {nuixRequestId}',
  exterroID: 'Exterro ID : {exterroRequestId}',
  engineProcessingTimeDependDes:
    'Cela peut prendre un certain temps en fonction de la longueur de la vidéo.',
  engineProcessingWaitDes1:
    'Vous pouvez attendre que le traitement se termine ici',
  engineProcessingWaitDes2: 'ou revenir à la',
  homePage: 'ACCUEIL',
  set: 'Régler',
  unredact: 'Ne Pas Caviarder',
  unredactAll: 'Ne Pas Caviarder Tout',
  editNote: 'Modifier la Note',
  deleteNote: 'Supprimer la Note',
  addNote: 'Ajouter une Note',
  editBuffer: 'Modifier la Tampon',
  deleteBuffer: 'Supprimer la Tampon',
  addBuffer: 'Ajouter une Tampon',
  redact: 'Caviarder',
  display: 'Afficher',
  redactAll: 'Caviarder Tout',
  maskVoice: 'Masquer la Voix',
  unmaskVoice: 'Dévoiler la Voix',
  reset: 'Réinitialiser',
  notesFormHelpTextLabels:
    'Séparez chaque étiquette par une virgule et/ou un espace.',
  notesFormLabels: 'Étiquettes',
  notesFormNotes: 'Remarques',
  searchViewPlaceholder: 'Cliquer sur Entrer pour rechercher...',
  forbidden: 'Interdit',
  logoutMessage:
    'Veuillez patienter pendant que vous êtes redirigé vers la page de connexion.',
  logoutWait: 'Déconnexion...',
  tdosGridHasMore: 'Faites défiler vers le bas pour charger plus de médias...',
  pageNotFound: 'Page Non Trouvée',
  pageNotFoundDes:
    "La page que vous recherchez a été déplacée, supprimée ou n'existe pas.",
  id: 'id',
  action: 'action',
  auditLogDialogTitle: "Journal d'Audit des Dossiers",
  approve: 'Approuver',
  approveCaseTitle: 'Approuver Le Dossier',
  approveCaseContent: 'Êtes-vous sûr de vouloir approuver ce dossier ?',

  archive: 'Archiver',
  archiveCaseTitle: 'Archiver Le Dossier',
  archiveCaseContent:
    'Êtes-vous sûr de vouloir archiver ce dossier ? Une fois archivé, le dossier sera supprimé de la vue sur le tableau de bord à moins que la bascule "Afficher tout" ne soit activée.',

  removeFilterTitle: 'Suppression De La Sortie',
  removeFilterHeads:
    'Veuillez confirmer : les têtes caviardées ne doivent PAS être incluses dans la vidéo finale !',
  removeFilterUdrs:
    'Veuillez confirmer : les UDR caviardés ne doivent PAS être incluses dans la vidéo finale !',
  removeFilterLicensePlates:
    "Veuillez confirmer : les plaques d'immatriculation et les véhicules expurgés ne doivent PAS être incluses dans la vidéo finale !",
  removeFilterLaptops:
    'Veuillez confirmer : les ordinateurs portables expurgés ne doivent PAS être incluses dans la vidéo finale !',
  removeFilterNotepads:
    'Veuillez confirmer : les blocs-notes caviardés ne doivent PAS être incluses dans la vidéo finale !',
  removeFilterCards:
    "Veuillez confirmer : les cartes d'identité expurgées ne doivent PAS être incluses dans la vidéo finale !",
  removeFilterPersons:
    'Veuillez confirmer : les personnes caviardées ne doivent PAS être incluses dans la vidéo finale !',
  removeFilterTextOverlays:
    'Veuillez confirmer : les superpositions de texte ne seront PAS affichées dans la sortie !',
  removeFilterConfirmDialog:
    "Êtes-vous sûr de vouloir supprimer ce filtre de la sortie ? Lorsqu'il est retiré, l'état du filtre ne peut pas être récupéré.",

  reopen: 'Rouvrir',
  reopenCaseTitle: 'Rouvrir Le Dossier',
  reopenCaseContent: 'Êtes-vous sûr de vouloir reouvrir ce dossier ?',

  date: 'date',
  deleteCaseTitle: 'Supprimer Le Dossier',
  deleteCaseContent:
    'Êtes-vous sûr de vouloir supprime ce dossier ? Une fois supprimé, le dossier ne peut pas être récupéré.',
  deleteCaseRequest:
    'Vous devez supprimer tous les médias de ce boîtier avant de supprimer.',

  deleteTdoTitle: 'Supprimer Le Sélection',
  deleteTdoContent: 'Êtes-vous sûr de vouloir supprimer le média sélectionné ?',

  export: 'Exporter',
  exportCaseTitle: 'Exporter Case',
  exportCaseContent: 'Êtes-vous sûr de vouloir exporter ce dossier ?',
  logs: 'Journaux',
  hash: 'hachage',

  user: 'usager',
  process: 'Traiter',
  processCaseTitle: 'Traiter Le Dossier',
  processCaseContent:
    'Lancez la recherche de POI sur toutes les vidéos. Veuillez vous assurer que vous avez téléchargé toutes les images et vidéos de POI. Voulez-vous continuer ?',

  userProfileMenu: "Menu Profil de l'Usager",
  signOut: 'Se Déconnecter',
  casesCreated: 'Dossiers Créés',
  numOfDaysOld: '# Jours',
  averageTimeProcessing: 'Temps de Traitement Moyen',
  casesInQueue: 'Dossiers en Attente',
  currentFailed: 'Échec actuel',
  statusDropdown: 'Liste Déroulante des Statuts',
  allStatuses: 'Tous les Statuts',
  showArchived: 'Afficher les Archives',
  newCase: 'Nouveau Dossier', // or 'Créer un Dossier'
  newImage: 'Nouveau Image',
  hideArchived: 'Cacher les Archives',
  deleting: 'Supprimant',
  archived: 'Archivé•e',
  new: 'Nouveau',
  pending: 'En attente',
  processing: 'En traitement',
  processed: 'Traité•e',
  error: 'Erreur',
  readyForReview: "Prêt pour l'examen",
  approved: 'Approuvé•e',
  readyForExport: "Prêt pour l'Exportation",
  deleted: 'Supprimé•e',
  deleteFolder: 'Supprimer le dossier',
  submit: 'Soumettre',
  caseName: 'Nom du Dossier',
  caseNameRequired: 'Nom du Dossier Requis',
  folderName: 'Nom du Classeur',
  folderNameRequired: 'Nom du Classeur Requis',
  deselectAll: 'Désélectionner Tout',
  selectAll: 'Sélectionner Tout',
  dropToUploadMedia: 'Déposer pour Télécharger des Médias',
  dragAndDrop: 'Glisser-Déposer',
  orClickToAddMedia: 'ou Cliquez pour Ajouter un Média',
  viewAuditLog: "Afficher le journal d'audit",
  processCase: 'Traiter le Dossier',
  approveCase: 'Approuver le Dossier',
  reopenCase: 'Rouvrir le Dossier',
  archiveCase: 'Archiver le Dossier',
  deleteCase: 'Supprimer le Dossier',
  exportCase: 'Exporter le Dossier',
  caseReviewManagement: "Gestion de l'examen des dossiers",
  addMedia: 'Ajouter des Médias',
  searchPlaceholder: 'Recherche...',
  searchCodePlaceholder: 'Search for code',
  loadingCodes: 'Codes De Chargement...',
  noCodes: 'Pas de Codes Disponibles...',
  daysOld: 'Jours',
  casesApproved: 'Dossiers Approuvés',
  casesReopened: 'Dossiers Rouverts',
  noItemsToDisplay: 'Aucun Élément à Afficher',
  itemsInQueue: 'Éléments dans la File d’Attente',
  noItemsInQueue: 'Aucun Élément dans la File d’Attente',
  lastUpdated: 'Dernière Mise à Jour',
  age: 'Âge',
  status: 'Statut',
  mediaDetails: 'Détails de Média',
  caseDetails: 'Détails de Dossier',
  caseActions: 'Actions de Dossier',
  caseMedia: 'Médias de Dossier',
  of: 'de',
  perPage: 'Par Page',
  details: 'Détails',
  archiveCaseConfirmDialog:
    'Êtes-vous sûr de vouloir archiver ce dossier ? Une fois archivée, l\'affaire ne sera plus visible sur le tableau de bord, sauf si l\'option "Voir tout" est activée.',
  deleteCaseConfirmDialog:
    "Êtes-vous sûr de vouloir supprimer cette affaire ? Une fois supprimée, l'affaire ne peut pas être récupérée.",
  back: 'Retourner',
  moveToTrash: 'Déplacer vers la corbeille',
  clearSelection: 'Effacer la sélection',
  downloadOutputFiles: 'Télécharger les fichiers de sortie',
  updateStatus: 'Mettre à jour le statut',
  batchStatusUpdateSuccess:
    'Statut mis à jour à {status} pour {count} fichiers.',
  batchStatusUpdateFailure: "{count} fichiers n'ont pas pu être mis à jour.",
  batchTrashConfirm:
    'Voulez-vous vraiment supprimer les {count} fichiers sélectionnés ?',
  batchTrashFilesSuccess:
    '{count, plural, one {# fichier déplacé vers la corbeille.} other {# fichiers déplacés vers la corbeille.}}',
  batchDeleteFilesSuccess:
    '{count, plural, one {# fichier supprimé.} other {# fichiers supprimés.}}',
  batchTrashFilesFailure: "{count} fichiers n'ont pas pu être supprimés.",
  batchMoveFilesSuccess: '{count} fichiers déplacés avec succès.',
  batchMoveFilesFailure: "{count} fichiers n'ont pas pu être déplacés.",
  batchTrashProgress: 'Suppression de {count}…',
  batchMoveProgress: 'Déplacement de {count}…',
  batchStatusProgress: 'Mise à jour de {count}…',
  deleteMessage:
    "Êtes-vous sûr de vouloir supprimer ceci ? Lorsqu'il est supprimé, il ne peut pas être récupéré.",
  deleteRedactedFilesMessage:
    'Cette action supprimera tous les fichiers caviardés. Le fichier original et les modifications de caviardage actuelles seront conservés.',
  moveToVirtualFolderNotAllowed:
    "Les dossiers ou les demandes ne peuvent pas être imbriqués dans les dossiers d'entrée ou de sortie.",
  invalidFileMove:
    'Déplacement invalide, les dossiers ne peuvent être déplacés que vers des demandes.',
  activeCases: 'Dossiers actifs',
  approvedCases: 'Dossiers approuvés',
  archivedCases: 'Dossiers archivées',
  reviewCases: "Cas en cours d'examen",
  noCases: 'Pas de dossiers',
  openCase: 'Ouvrir le dossier',
  sourceMedia: 'Médias sources',
  redactedMedia: 'Médias caviardés',
  noMedia: 'Pas de Médias',

  exportPending: 'Cette dossier sera exportée dans un instant.',
  exportRunning: "Cette dossier s'exporte en ce moment même !",
  exportComplete:
    'Ce dossier est prêt à être téléchargé ! Veuillez cliquer sur "télécharger" ci-dessous.',
  exportFailed: "Cette dossier n'a pas réussi à exporter.",
  exportDefault: 'Veuillez attendre que votre exportation commence.',

  readyForReviewTitle: 'Prêt à examiner le dossier',
  readyForReviewTitleContent:
    'Êtes-vous sûr que ce dossier est prêt à être examiné ?',

  caseIsNew: 'Le dossier est nouveau',
  caseIsProcessing: 'Le dossier est en cours de traitement',
  caseHasAnError: 'Le dossier a une erreur',
  caseIsReadyForReview: 'Le dossier est prête à être examinée',
  caseHasBeenApproved: 'Le dossier a été approuvé',
  caseIsReadyForExport: "Le dossier est prête pour l'exportation",
  caseHasBeenDeleted: 'Le dossier a été supprimée',
  caseStatusWasNotUpdated: "Le statut de le dossier n'a pas été mis à jour",

  isBeingProcessed: 'est en cours de traitement',
  couldNotBeProcessed: "n'a pas pu être traité",

  newCaseCreated: 'Nouveau cas créé',
  caseDeleted: 'Cas supprimé',
  caseArchived: 'Cas archivé',
  noNotifications: 'Aucune notification',

  showNonRedactedOverlays: 'Afficher les Superpositions Non Rédigées',
  showNonRedactedOverlaysContent:
    "Avertissement ! La prévisualisation des superpositions non rédigées peut entraîner un retard de rendu. Un décalage peut se produire lorsqu'un grand nombre de superpositions sont visibles.",

  timelineUdr: 'UDR',
  timelineHead: 'TÊTE',
  timelinePerson: 'PERSONNE',
  timelinePoi: 'POI ',
  timelinePlate: 'PLAQUE',
  timelineVehicle: 'VÉHICLE',
  timelineLaptop: 'ORDINATEUR ',
  timelineNotepad: 'BLOC-NOTES (PII)',
  timelineCard: "CARTE D'IDENTITE (PII)",
  timelineTranscription: 'AUDIO',
  timelineBackgroundBlur: "FLOU D'ARRIÈRE-PLAN",
  timelineComments: 'COMMENTAIRES',
  created: 'Créé•e',
  running: 'En cours',
  view: 'Voir',
  navigationDiscardWarning:
    'Vous avez des modifications non enregistrées sur cette page. Voulez-vous quitter cette page et annuler vos modifications ou rester sur cette page ?',
  mostRecent: 'Plus récent',
  all: 'Tout',
  head: 'Tête',
  face: 'Tête',
  poi: 'POI',
  poim: 'POI',
  udr: 'UDR',
  laptop: 'Ordinateur',
  manualInterp: 'Manuel',
  plate: 'Plaque',
  plateOrVehicle: 'Plaque / Véhicule',
  licensePlate: 'Plaque',
  vehicle: 'Véhicule',
  notepad: 'Bloc-notes',
  card: "Carte d'identité (PII)",
  person: 'Personne',
  fetchDetAssets: "Récupération des actifs de détection d'objets...",
  procDetAssets: "Traitement des actifs de détection d'objets...",
  caseStatusChanged: "Le statut de l'affaire a été modifié",
  caseStatusNotChanged: "Le statut de l'affaire n'a pas été modifié",
  caseNotDeleted: "Le cas n'a pas été supprimé",
  fileDeleted: 'Fichier supprimé',
  fileFailedDeleted: 'Échec de la suppression du fichier',
  fileFailedCreateTDO: "Échec de la création du fichier d'exportation TDO",
  exportTdoNotCreated: "Le TDO d'exportation n'a pas pu être créé",
  caseCouldNotExported: "Le cas n'a pas pu être exporté",
  failedToFetchCase: 'Échec de la récupération du cas',
  caseNameChange: "Le nom de l'affaire a été changé en {caseName}",
  caseNameChangeFail: "Échec du changement de nom de l'affaire: {error}",
  notiDismissFail: 'La notification ne pouvait pas être rejetée',
  notiClearFail: "La notification n'a pas pu être effacée",
  failedToFetchMedia: 'Échec de la récupération du média',
  failedToFetchComments: 'Échec de la récupération des commentaires',
  fileUploadSuccess: 'Fichier téléchargé avec succès',
  fileUploadFail: 'Le téléchargement du fichier a échoué',
  latestRedactDeleted: 'Le dernier fichier caviardé a été supprimé avec succès',
  latestRedactDeletedFail:
    'La suppression du dernier fichier caviardé a échoué',
  downloadMediaFail: 'La tentative de téléchargement du média a échoué',
  procNotFinishedWait:
    "Le traitement de ce fichier n'est pas terminé. Attendez que l'ingestion soit terminée.",
  engineRetryError: "Une erreur s'est produite lors de la réessai du moteur.",
  successfulRedact: 'Fichier expurgé avec succès.',
  successfulRedactOtherFile:
    'Fichier expurgé avec succès. (ID du fichier : {fileId})',
  successfulRedactOtherFileNamed: '« {fileName} » expurgé avec succès.',
  engineJobFailureMsg:
    "Le moteur n'a pas réussi à fonctionner avec l'identifiant de moteur suivant: {engineId}",

  casemediatitle: 'MÉDIAS DE CAS',
  viewAllCases: 'Afficher tous les cas',
  addCase: 'Ajouter un dossier',
  addFolder: 'Ajouter un classeur',
  createdSuccessfully: 'a créé avec succès',
  failedToCreate: "n'a pas créé",
  caseDashboard: 'Tableau de Bord du Cas',
  viewAllMedia: 'Voir tous les médias',
  searchFoldersAndCases: 'Chercher de Dossiers et Cas...',
  searchResults: 'Résultats de Cherche',
  searchInFolder: 'Chercher dans ce dossier',
  searchingIn: 'Recherche dans : {folderName}',
  searchSelectedFolder: 'Dossier actuel',
  searchSelectedRequest: 'Demande actuelle',
  searchSelectedFolderTooltip: 'Rechercher dans le dossier actuel',
  searchSelectedRequestTooltip: 'Rechercher dans la demande actuelle',
  searchEverything: 'Tout',
  searchEverythingTooltip:
    'Rechercher dans tous les dossiers, demandes et fichiers',
  searchScopeAriaLabel: 'Portée de recherche',
  searchResultsFound: '{count} trouvé(s)',
  searchResultMedia: 'Média',
  searchResultFolder: 'Dossier',
  searchResultRequest: 'Demande',
  searchResultCreated: 'Créé : {date}',
  searchResultFileId: 'ID du fichier : {fileId}',
  endOfResults: 'Fin des résultats',
  openFile: 'Ouvrir le fichier',
  searchInColumn: 'Chercher dans cette colonne...',
  clearSearch: 'Effacer la recherche',
  search: 'Chercher',
  name: 'Nom',
  dateCreated: 'Date de Création',
  originalLocation: "Emplacement d'origine",
  trashedBy: 'Déplacé par',

  noCommentsFound: 'Aucun commentaire trouvé dans ce média.',
  addNewComment: 'Ajouter un commentaire',
  timeSyncCommentTooltip: 'Sauter au cadre',
  timeSyncMediaTime: 'Heure des médias {time}',
  postedOn: 'Publié•e',
  editedOn: 'Modifié•e',
  comment: 'Commenter',
  successfullySavedComment: 'Le commentaire enregistré avec succès.',
  failedToSaveComment: "Échec de l'enregistrement du commentaire.",
  failedToFetchUser: "N'a pas réussi à récupérer l'utilisateur.",

  read: 'Lu',
  markAsRead: 'Marquer comme lu',
  edit: 'Modifier',
  hide: 'Cacher',
  unhide: 'Afficher',
  filter: 'Filtrer',
  onscreenOnlyFilterTooltip: "Afficher seulement les groupes à l'écran",
  onscreenOnlyToggleLabel: "À l'écran seulement",
  onscreenScopeBarLabel: "Affichage des groupes à l'écran seulement",
  onscreenScopeBarShowAll: 'Afficher tout',
  noObjectsOnscreen: "Aucun objet à l'écran à cette position",
  noObjectsOnscreenFiltered:
    'Aucun objet à cette position ne correspond aux filtres actuels',
  filterDetections: 'Filtrer Détections', // not in use
  removeFromOutput: 'Retirer de la Sortie',
  viewHidden: 'Vue Cachée',
  viewFilter: 'Vue Filtre',
  hidden: 'Cachée',
  hideFilter: 'Cacher Filtre',
  sortByTimestamp: 'Trier par Horodateur',
  sortByDateCreated: 'Trier par Date de Création',
  viewPeopleFilter: 'Vue du filtre des personnes',
  hidePeopleFilter: 'Cacher du filtre des personnes',
  sortAscend: 'Trier en ordre croissant',
  sortDescend: 'Trier par ordre décroissant',
  commenter: 'Commentateur',
  legacyMediasTitle: 'Média non attribué',
  profileName: 'Profile Name',
  isDefault: 'Défaut',
  createdBy: 'Créé par',
  modifiedBy: 'Modifié par',
  createdOn: 'Créé',
  modifiedOn: 'Modifié',

  redaction: 'Caviardage',
  headDetection: 'Détection de Tête',
  bodyDetection: 'Détection de Corps',
  personLocation: 'Localisation de la Personne',
  personOfInterest: "Personne d'Intérêt",

  menuOptionOpen: 'Ouvrir',
  menuOptionDeleteFolder: 'Supprimer',
  menuOptionRenameFolder: 'Renommer',
  menuOptionFolderDetails: 'Détails du dossier',
  menuOptionMoveFolder: 'Déplacements',
  menuOptionDownloadAll: 'Télécharger tout',

  menuOptionEditFileAttributes: 'Modifier les attributs',
  menuOptionAddTagFile: 'Ajouter une étiquette',
  menuOptionReviewFile: 'Examiner le fichier',
  menuOptionViewLogFile: 'Afficher le journal',
  menuOptionStatusHistory: 'Historique des statuts',
  menuOptionCopyFile: 'Copier le fichier',
  menuOptionPlayFile: 'Lire le fichier',
  menuOptionPlayOriginal: "Jouer l'original",
  menuOptionPlayRedacted: 'Jouer caviardé',
  menuOptionViewOriginal: "Voir l'original",
  menuOptionViewRedacted: 'Voir caviardé',
  menuOptionDownloadFile: 'Télécharger le fichier',
  menuOptionDownloadLog: 'Télécharger le journal',
  menuOptionDownloadOriginalFile: 'Télécharger le fichier original',
  menuOptionDownloadOriginalFilePdf: 'Télécharger le fichier original (PDF)',
  menuOptionDownloadOcrEnrichedFilePdf:
    'Télécharger le fichier enrichi par ROC (PDF)',
  menuOptionDownloadOriginalFormatFile:
    'Télécharger le fichier original ({ext})',
  menuOptionDownloadUploadedFile: 'Télécharger le fichier téléversé',
  downloadOriginalFormatUnavailable:
    "La version téléversée de ce fichier n'est pas disponible.",
  menuOptionDownloadOcrEnrichedFile: 'Télécharger le fichier enrichi par ROC',
  downloadOcrEnrichedUnavailable:
    'La copie enrichie par ROC de ce fichier est introuvable.',
  menuOptionDownloadRedactedFile: 'Télécharger le fichier caviardé',
  menuOptionDeleteFile: 'Supprimer le fichier',
  menuOptionDownloadAllOutputFiles: 'Télécharger tous les fichiers de sortie',
  menuOptionEdit: 'Modifier',
  menuOptionRedactedFiles: 'Fichiers Caviardés',
  menuOptionPlay: 'Jouer',
  menuOptionView: 'Voir',
  menuOptionDownloadRedactedMedia: 'Télécharger le Média Caviardé',
  menuOptionDownloadAuditLog: "Télécharger le Journal d'Audit",
  menuOptionRemoveRedactedFiles: 'Retirer les Fichiers Caviardés',
  menuOptionOriginalFile: 'Fichier Original',
  menuOptionCurrentFile: 'Fichier Actuel',
  addRequest: 'Ajouter une demande',
  folderLocationCheckbox: 'Emplacement du dossier',
  createdDateCheckbox: 'Date de création',
  redactionNameCheckbox: 'Nom du caviardage',
  fileNameCheckbox: 'Nom du fichier',
  modifiedDateCheckbox: 'Date de modification',
  hasAudioRedactionsCheckbox: 'A des caviardages audio',
  fileId: 'ID du fichier',
  durationCheckbox: 'Durée',
  fileStatusCheckbox: 'Statut du fichier',
  hasVideoRedactionsCheckbox: 'A des caviardages visuels',
  exportMediaListSuccess: 'Liste des médias exportée avec succès',
  exportMediaListFailure:
    "Échec de l'exportation de la liste des médias. Veuillez réessayer.",
  exportMediaList: 'Exporter la liste des médias',
  exportMediaListLoading: 'Exportation de la liste des médias...',
  exportMediaSubTextCaseMedia:
    'Vous exportez la hiérarchie complète des dossiers, y compris tous les sous-dossiers imbriqués et les noms des fichiers. La structure sera conservée dans le fichier exporté.',
  exportMediaListNoFiles:
    'Aucun fichier trouvé dans le dossier/la demande sélectionné(e)!',
  exportMediaSubTextRequest:
    'Vous exportez les détails des fichiers pour la demande sélectionnée uniquement.',
  exportMediaSubTextFolder:
    'Vous exportez les détails des fichiers pour le dossier sélectionné uniquement.',
  exportMediaSubTextMainPageView:
    'Vous exportez tous les fichiers de votre organisation. Cela peut prendre quelques instants en fonction du nombre total de fichiers.',
  exportIncludedTitle: "Inclus dans l'exportation:",
  unselectAll: 'Tout désélectionner',
  searchFoldersAndRequests: 'Chercher',
  requestName: 'Nom de la demande',
  requestNameRequired: 'Nom de la demande requis',
  moveFolder: 'Déplacer le dossier',
  confirmMove: 'Déplacements',
  noFoldersFound: 'Aucun dossier trouvé.',

  moveFolderSuccess: 'Le déplacement du dossier ou de la demande est réussi.',
  moveFolderFailure: 'Échec du déplacement du dossier ou de la demande.',
  renameSuccess: 'Le renommage a été effectué avec succès.',
  folderCannotNestedMoreThanTwoLevel:
    'Les dossiers ne peuvent pas être imbriqués à plus de deux niveaux.',
  requestShouldBeOneLevelDeep:
    'Les demandes doivent être imbriquées au moins à un niveau de profondeur dans un dossier principal.',
  containsNestedFolders:
    'Le dossier sélectionné contient des dossiers imbriqués. Les dossiers ne peuvent pas être imbriqués sur plus de deux niveaux.',
  foldersShouldNestedInRequest:
    'Les dossiers ne peuvent pas être imbriqués dans les demandes.',
  requestCannotNestedInRequests:
    'Les demandes ne peuvent pas être imbriquées les unes dans les autres.',
  nameExistsInFolder:
    'Ce nom existe déjà pour ce dossier sélectionné. Désolé, les noms en double ne sont pas autorisés.',
  nameExistsCheckFailed: "Échec de la vérification de l'existence du nom pour",
  errorAddingMedia: "Une erreur s'est produite lors de l'ajout du média.",
  errorUpdatingMedia:
    "Une erreur s'est produite lors de la mise à jour des médias.",
  errorRemovingMedia:
    "Une erreur s'est produite lors de la suppression du support.",
  errorRemovingFiles:
    "Une erreur s'est produite lors de la suppression d'un ou plusieurs fichiers.",
  errorPreloadingMedia:
    "Une erreur s'est produite lors du préchargement de la liste des médias.",
  errorUnlinkingFiles:
    "Une erreur s'est produite lors du déliaison d'un ou plusieurs fichiers.",
  invalidRequestToIngest:
    'Le fichier doit être téléchargé vers la demande. Veuillez sélectionner une demande valide à ingérer.',
  selectRequestToIngest: 'Sélectionnez une demande à ingérer',
  confirmSelectRequest: 'Sélectionnez',
  noRedactPermission:
    "Veuillez vous assurer que l'utilisateur a le rôle d'éditeur REDACT.",
  fetchRootFolderFailed: 'Impossible de récupérer les dossiers.',
  createRootFolderFailed: "Échec de la création du dossier racine de l'org.",
  sourceAndDestSame:
    "Le dossier sélectionné ne peut pas être déplacé à l'intérieur de lui-même.",
  folderAlreadyExitsInParent:
    'Le dossier sélectionné existe déjà dans le dossier parent.',
  requestAlreadyExitsInParent:
    'La demande sélectionnée existe déjà dans le parent.',
  inValidSource: 'Mouvement non valide. Veuillez réessayer.',
  inValidDest: 'Dossier cible non valide. Veuillez réessayer.',
  code: 'Code',
  codeName: 'Nom de Code',
  description: 'Description',
  detection: 'Détection',
  interpolationTitle: 'Interpolation',
  advanced: 'Avancé',
  redactions: 'Caviardages',
  redactionCodes: 'Codes de Caviardage',
  statuses: 'Statuts',
  redactionStatuses: 'Statuts de caviardage',
  addNewCode: 'Ajouter un nouveau code',
  enabled: 'Activé',
  color: 'Couleur',
  editLock: 'Verrouiller les modifications',
  editLockTooltip:
    'Lorsque verrouillé, les caviardages dans ce statut ne peuvent plus être modifiés.',
  statusColorLightBlue: 'Bleu clair',
  statusColorBlue: 'Bleu',
  statusColorOrange: 'Orange',
  statusColorRed: 'Rouge',
  statusColorGreen: 'Vert',
  required: '(obligatoire)',
  recommended: '(recommandé)',
  unavailable: 'indisponible',
  type: 'Type',
  mediaType: 'Type de média',
  selectMediaTypes: 'Sélectionner le(s) type(s) de média',
  customColor: 'Couleur personnalisée',
  openColorPicker: 'Ouvrir le sélecteur de couleurs',
  veritoneStatusColors: 'Couleurs des statuts Veritone',
  additionalColors: 'Couleurs supplémentaires',
  create: 'Créer',
  addNewStatus: 'Ajouter un nouveau statut',
  editStatus: 'Modifier le statut',
  statusName: 'Nom du statut',
  statusNameAlreadyExists:
    'Un statut portant ce nom existe déjà. Choisissez un autre nom.',
  statusType: 'Type de statut',
  statusTypeImage: 'Image',
  statusTypeDocument: 'Document',
  statusTypeAudioVideo: 'Audio et vidéo',
  deleteStatus: 'Supprimer le statut',
  deleteStatusStillDisplayedNote:
    'Tous les fichiers utilisant actuellement ce statut continueront de l’afficher, mais il ne pourra plus être appliqué à d’autres fichiers.',
  permanentlyDeleteStatus: 'Supprimer définitivement le statut',
  permanentlyDeleteStatusNote:
    'Tous les fichiers utilisant actuellement ce statut continueront d’afficher le nom du statut, mais perdront toutes ses autres propriétés, y compris sa couleur.',
  viewDeletedStatuses: 'Voir les statuts supprimés ({count})',
  deletedStatuses: 'Statuts supprimés',
  backToStatuses: 'Retour aux statuts',
  // « restore » réutilisé de la fonctionnalité corbeille.
  restoreStatusNameTaken: 'Un statut portant ce nom existe déjà.',
  restoreCustomStatusSuccess: 'Statut « {name} » restauré avec succès.',
  restoreCustomStatusFailure:
    'Une erreur s’est produite lors de la restauration du statut.',
  statusUnknown: 'Inconnu',
  saveCustomStatusSuccess: 'Statut « {name} » enregistré avec succès.',
  saveCustomStatusFailure:
    "Une erreur s'est produite lors de l'enregistrement du statut.",
  deleteCustomStatusSuccess: 'Statut « {name} » supprimé avec succès.',
  deleteCustomStatusFailure:
    "Une erreur s'est produite lors de la suppression du statut.",
  reorderCustomStatusesFailure:
    "Une erreur s'est produite lors de la réorganisation des statuts.",
  reorderStatusHandle:
    'Réorganiser {name}. Appuyez sur la flèche vers le haut ou vers le bas pour le déplacer.',
  settingsProfile: 'Profils',
  settingsProfileTitle: 'Profil des Paramètres: ',
  addNewSettingsProfile: 'Ajouter un nouveau profil',
  missingEmail: "L'e-mail de l'utilisateur n'est pas disponible.",
  missingProfileOrEmail:
    "Le profil ou l'e-mail de l'utilisateur n'est pas disponible.",
  deleteSettingsProfile: 'Supprimer le profil',
  fetchProfileListFailure:
    "Une erreur inattendue s'est produite lors de l'extraction de la liste des profils.",
  createSettingsProfileFailure:
    "Une erreur inattendue s'est produite lors de la création du profil de paramètres.",
  updateSettingsProfileFailure:
    "Une erreur inattendue s'est produite lors de la mise à jour du profil des paramètres.",
  deleteSettingsProfileFailure:
    "Une erreur inattendue s'est produite lors de la suppression du profil des paramètres.",

  createdDateTime: "Date d'ajout",
  modifiedDateTime: 'Date de modification',
  redactionCodeDetails: 'Détails du code de rédemption',
  displayCode: "Code d'affichage",
  displayCodeRule: 'De 2 à 20 caractères, sans espaces.',
  descriptionOptional: 'Description (facultative)',
  saveRedactionCodeSuccess:
    "L'enregistrement du code de rédemption avec succès.",
  savedRedactionCodeFailure:
    'Une erreur est survenue lors de la sauvegarde du code de rédaction.',
  fetchRedactionCodesFailure:
    "Une erreur s'est produite lors de l'enregistrement du code de rédaction: {responseCode}",
  deleteRedactionCode: 'Supprimer le code de rédemption',
  deleteRedactionCodeSuccess: 'Suppression du code de rédaction réussie.',
  deleteRedactionCodeFailure:
    "Une erreur s'est produite lors de la suppression du code de rédaction.",
  checkRedactionCodeExistsSuccess:
    "Échec de l'enregistrement. Il semble que le code ou le nom de code de réaction existe déjà. Veuillez vérifier et utiliser un autre code ou nom de code.",
  checkRedactionCodeExistsFailure:
    "Une erreur s'est produite lors de la validation du code de rédaction existant.",
  illuminateFolderNameMsg:
    "Le nom de dossier 'Illuminate App' n'est pas autorisé au niveau de la racine car il est réservé à l'application Illuminate. Veuillez fournir un nom de dossier différent.",
  moveFileToCaseSuccess: 'Fichier déplacé avec succès.',
  moveFileToCaseFailure:
    "Une erreur inattendue s'est produite lors du déplacement du fichier. Veuillez réessayer plus tard.",
  fileTdoWithCaseSuccess: '{fileName} déplacé avec succès.',
  fileTdoWithCaseFailure:
    'Échec du déplacement du fichier {fileName}. {message}',
  menuOptionMoveFile: 'Déplacer',
  sourceAndDestCaseOfFileSame:
    'Impossible de se déplacer car les demandes de la source et de la destination sont identiques.',
  tdoIsLocked: "Ce fichier est en cours d'édition par {name}.",
  viewModeBanner: 'Vous êtes actuellement en mode lecture seule.',
  olpViewOnlyBanner:
    "Vous disposez uniquement d'autorisations en lecture seule pour ce fichier. Si vous avez besoin d'une autorisation de modification, veuillez contacter votre administrateur.",
  folderViewOnlyTooltip:
    "Lecture seule — vous n'avez pas l'autorisation de modifier ce dossier.",
  viewOnlyActionDisabled: 'Autorisation de modification requise.',
  statusLockEditsBanner: 'Changez le statut pour activer les modifications.',
  bannerDismiss: 'Ignorer',
  editLockEngagedHelp:
    'Pour activer les modifications, passez le statut à brouillon ou mettez à jour la politique de verrouillage depuis la page des statuts.',
  invalidDataWarning:
    'Données invalides chargées ! Veuillez contacter le support Veritone.',
  mustRefresh:
    'Vous devez actualiser la page pour afficher les dernières modifications.',
  mustRefreshToEdit: 'Vous devez actualiser la page pour pouvoir la modifier.',
  tdoExternallyModifiedWarning: 'Ce fichier a été modifié en externe.',
  fileModifiedTitle: 'Fichier modifié',
  fileModifiedDescription:
    'Ce fichier a été modifié. Voulez-vous le recharger avec les dernières biffures ?',
  yesReload: 'Oui, recharger',
  dragOrDoubleClickToResize: 'Glisser ou double-cliquer',
  cannotDeleteFileInUse:
    "Impossible de supprimer -- fichier en cours d'utilisation.",
  cannotDeleteFileJobsInProcessing:
    'Impossible de supprimer le dossier car certains dossiers sont en cours de traitement. Veuillez réessayer plus tard.',
  downloadFailure:
    "Une erreur inattendue s'est produite lors du téléchargement du fichier. Veuillez réessayer plus tard.",
  downloadAllJobFailure:
    "Une erreur inattendue s'est produite lors du téléchargement de tous les fichiers de sortie. Veuillez réessayer plus tard.",
  downloadAllComplete: 'Télécharger Tous complétés.',
  // VE-26426: download progress toast and header tray.
  downloadProgress: 'Téléchargement {done}/{total} — {progress}',
  downloadProgressNoSize: 'Téléchargement {done}/{total} — {loaded}',
  downloadProgressMoreFiles: '+{count} autres',
  downloadTrayTitle: 'Téléchargements',
  notificationsTooltip: 'Notifications',
  downloadTrayQueuedCount: 'Fichiers en attente : {count}',
  downloadTrayClose: 'Fermer les téléchargements',
  downloadTrayOpen: 'Ouvrir',
  downloadTrayFileDownloading: 'Téléchargement en cours',
  downloadTrayClear: 'Effacer',
  downloadTrayFileDone: 'Terminé',
  downloadTraySizeStatus: '{size} • {status}',
  downloadTrayFileError: 'Échec',
  downloadTrayFileQueued: 'En attente',
  downloadTrayFileProgressNoSize: '{loaded} téléchargés',
  editNameTDOSuccess: 'Nom TDO mis à jour avec succès.',
  editNameTDOFailed: 'La mise à jour TDO a échoué.',
  statusUpdatedSuccess: 'Statut mis à jour avec succès en {status}.',
  statusUpdateFailed: 'La mise à jour du statut a échoué.',
  saveRedactionStatusesSuccess: 'Statut enregistré avec succès.',
  saveRedactionStatusesFailure:
    "Une erreur s'est produite lors de l'enregistrement des statuts de caviardage.",
  fetchRedactionStatusesFailure:
    "Une erreur s'est produite lors de la récupération des statuts de caviardage.",

  noRedactionsTitle: 'Aucun caviardage !',
  noRedactionsText:
    "Aucun caviardage n'a été appliqué à ce dossier ! Si c'est exact, veuillez confirmer pour continuer.",
  detectHeadObjects: 'Tête et objets',
  detectPersonObjects: 'Personne et Objets',

  cannotUndo: 'Ne peut pas annuler la dernière action',
  cannotRedo: "Ne peut pas rétablir l'action précédente",
  groupingTools: 'Outils de Groupement',
  mergeUnmergeSelect: 'Fusionner/Défusionner la Sélection',
  mergeUnmerge: 'Fusionner/Défusionner',
  selectGroupRange: 'Sélectionner une Plage de Groupes',

  processTranscriptionSuccess: 'La transcription est terminée.',
  processVoiceMaskSuccess: 'Masquer la Voix est terminée..',
  mergedGroup: 'Groupe fusionné',
  merged: 'Fusionné',
  mixed: 'Mélangé',
  allSegments: 'Tous les segments',
  showSegments: 'Afficher les segments',
  hideSegments: 'Masquer les segments',
  segments: 'Segments',
  pinToTop: 'Épingler en haut',
  unpin: 'Désépingler',
  mergeWithPinnedGroup: 'Fusionner avec le groupe épinglé',
  mergeWithNamedGroup: 'Fusionner avec un groupe nommé',
  merge: 'Fusionner',
  unmerge: 'Défusionner',
  clear: 'Effacer',
  select: 'Sélectionner',
  deselect: 'Désélectionner',
  unMergeFromGroup: 'Dissocier du groupe',
  selectSegment: 'Sélectionner un segment',
  deselectSegment: 'Désélectionner un segment',
  deleteSegment: 'Supprimer un segment',
  selected: 'Sélectionné',
  and: 'et',
  group: 'Groupe',
  segment: 'Segment',
  apply: 'Appliquer',
  groupNameEnterText: 'Saisir un nom de groupe',
  mergeConfirm: 'Confirmation de fusion',
  unmergeConfirm: 'Confirmation de la désunion',
  mergeConfirmText:
    "Création d'un nouveau groupe fusionné. Veuillez confirmer le nom du groupe :",
  mergeMultipleText:
    'La sélection comprend plusieurs groupes nommés ! Veuillez sélectionner un nom pour le groupe fusionné :',
  unmergeConfirmText:
    'Déplacement du(des) segment(s) vers un nouveau groupe. Veuillez confirmer le nom du groupe.',
  labelTextfield: 'Entrez un nom de groupe',
  mergeTextBox: 'Groupe fusionné',
  rotationPreview: 'Aperçu de la rotation',
  rotateImage: "Faire pivoter l'image",
  rotateConfirmTitle: 'Confirmation de la rotation',
  rotateConfirmDes:
    "Attention ! La rotation supprimera tous les UDR existants et les objets détectés ! \nVous pourrez reprendre l'édition après le traitement de la vidéo.",
  rotateConfirmDesImage:
    "Attention ! La rotation supprimera tous les UDR existants et les objets détectés ! \nVous pourrez reprendre l'édition après le traitement de l'image.",
  rotateConfirmDesVideo:
    "Attention ! La rotation supprimera tous les UDR existants et les objets détectés ! \nVous pourrez reprendre l'édition après le traitement de la vidéo.",
  selectDetectOption:
    "Sélectionnez les types d'objets que vous souhaitez détecter.",
  rotateImageSuccess: "Traitement de la rotation de l'image.",
  rotateVideoSuccess: 'Traitement de la rotation vidéo.',
  rotateImageFailure:
    "Une erreur inattendue s'est produite lors de la rotation de l'image.",
  rotateVideoFailure:
    "Une erreur inattendue s'est produite lors de la rotation de la vidéo.",
  errorFetchingAuditLog:
    "Erreur inattendue lors de la récupération des journaux d'audit. Veuillez réessayer.",
  errorFetchingTDOState: "Erreur lors de la récupération de l'état TDO.",
  errorFetchingGovQAIntegrationInfo:
    "Impossible de récupérer les informations d'intégration GovQA.",
  missingGovQAIntegrationConfig:
    "La configuration de l'intégration GovQA est incomplète.",
  errorFetchingExternalIntegrationInfo:
    "Impossible de récupérer les informations d'intégration externe.",
  missingExternalIntegrationConfig:
    "La configuration de l'intégration externe est incomplète.",
  errorFetchingFOIAXpressIntegrationInfo:
    "Impossible de récupérer les informations d'intégration FOIAXpress.",
  missingFOIAXpressIntegrationConfig:
    "La configuration de l'intégration FOIAXpress est incomplète.",
  errorFetchingCasepointIntegrationInfo:
    "Impossible de récupérer les informations d'intégration Casepoint.",
  missingCasepointIntegrationConfig:
    "La configuration de l'intégration Casepoint est incomplète.",
  errorFetchingExterroIntegrationInfo:
    "Impossible de récupérer les informations d'intégration Exterro.",
  missingExterroIntegrationConfig:
    "La configuration de l'intégration Exterro est incomplète.",
  errorFetchingNuixIntegrationInfo:
    "Impossible de récupérer les informations d'intégration Nuix.",
  missingNuixIntegrationConfig:
    "La configuration de l'intégration Nuix est incomplète.",
  errorUnknown: 'Erreur inconnue.',
  errorSendingFile:
    "Impossible d'envoyer le fichier. Veuillez contacter votre administrateur.",
  defaultSettings: 'Paramètres par défaut',
  inverseBlur: 'Flou Inversé',
  background: 'Arrière-plan',
  backgroundBlur: 'Flou arrière-plan',
  addBackgroundBlur: 'Ajoutez Flou arrière-plan',
  addBackgroundBlurTip:
    "Appliquez un flou d'arrière-plan avec des horodatages correspondants à toutes les zones où le type d'objet est sélectionné",
  updateExistingSpans: 'mettre à jour & enregistrer',
  addBackgroundBlurMessage: "Ajoutez un flou d'arrière-plan en même temps",
  useBackgroundBlurTip:
    "Utilisez la ligne de chronologie du flou d'arrière-plan pour définir le niveau de flou d'arrière-plan et les intervalles de temps de début/fin",
  autoAddBackgroundBlur:
    "Ajouter automatiquement un flou d'arrière-plan lorsqu'un groupe de flou inversé est sélectionné",
  autoAddBackgroundBlurLine2:
    'Inclut lorsque des UDR à flou inversé sont créées ou suivies manuellement',
  noPermissions:
    'Vous ne disposez pas des autorisations nécessaires pour accéder à cette page.',
  contactAdministrator:
    'Si le problème persiste, veuillez contacter votre administrateur.',
  unsupportedFileType: 'Type de fichier non pris en charge ({contentType})',

  history: 'Historique',
  undo: '{actionName, select, undefined {Annuler la dernière action} other {ANNULER {actionName}}}',
  redo: "{actionName, select, undefined {Rétablir l''action précédente} other {RÉTABLIR {actionName}}}",
  moveOrResizeUDR: 'déplacer/redimensionner UDR',
  moveUDR: 'déplacer UDR',
  liveTrackUdr: 'suivi en direct UDR',
  moveDetectionOverlay: 'déplacer de {# type} la superposition ',
  resizeDetectionOverlay: 'redimensionner {# type} la superposition ',
  drawUDR: 'dessiner UDR',
  deleteUDRgroup: 'supprimer la groupe udr',
  deleteCluster: 'supprimer le groupe',
  trackUDR: 'suivre UDR',
  changeUDRShape: 'changer la forme UDR',
  changeDetectionShape: 'changer de {# typeObject} la forme',
  changeMergedGroupShape: 'changer la forme du groupe fusionné',
  noDescription: '(aucune description)',
  currentState: 'État actuel',
  stepsBack:
    '{index, plural, one {# étape en arrière} other {# étapes en arrière}}',
  stepsForward:
    '{index, plural, one {# étape en avant} other {# étapes en avant}}',
  cannotUndoFurther: "Impossible d'annuler davantage",
  cannotRedoFurther: 'Impossible de rétablir davantage',
  jumpedBackSteps: 'Reculé de {steps, plural, one {# étape} other {# étapes}}',
  jumpedForwardSteps:
    'Avancé de {steps, plural, one {# étape} other {# étapes}}',
  changeRedactionCode: 'changer le code de rédaction',
  permanentDeleteTitle: 'Confirmer la suppression permanente',
  permanentDeleteContent:
    'Vous êtes sur le point de supprimer définitivement {count} enregistrements. Vous ne pourrez pas annuler cette action.',
  restoreTitle: 'Confirmer la restauration',
  restoreContent:
    'Vous êtes sur le point de restaurer {count} enregistrements. Êtes-vous sûr ?',
  restore: 'Restaurer',
  trash: 'Corbeille',
  ID: 'ID',
  duration: 'Durée',
  lengthColumn: 'Longueur',
  copyFileId: "Copier l'ID du fichier",
  copied: 'Copié',
  pageCountShort: '{count} pages',
  daysUntilDeletion: 'Suppression permanente',
  errorPreloadingTrashMedia:
    "Une erreur s'est produite lors du préchargement de la liste des médias de la corbeille.",
  trashFilesDeleted: 'Fichiers supprimés avec succès.',
  trashFoldersDeleted: 'Dossiers supprimés avec succès.',
  trashFilesRestored: 'Fichiers restaurés avec succès.',
  trashFoldersRestored: 'Dossiers restaurés avec succès.',
  trashNoFoldersRestored: 'Aucun dossier valide à restaurer.',
  trashRestoreFilesError:
    "Une erreur s'est produite lors de la restauration des fichiers.",
  trashFoldersRestoredWithLeftovers:
    "Certaines données de corbeille n'ont pas pu être supprimées de {count, plural, one {# dossier restauré} other {# dossiers restaurés}}.",
  trashNoFilesRestored: "Aucun des fichiers sélectionnés n'a pu être restauré.",
  trashFilesPartiallyRestored:
    "{count, plural, one {# fichier restauré} other {# fichiers restaurés}} sur {total}. {failed, plural, one {# n'a pas pu être restauré} other {# n'ont pas pu être restaurés}}.",
  trashFilesRestoredWithLeftovers:
    "{count, plural, one {Certaines données de corbeille n'ont pas pu être supprimées de # fichier restauré; il peut ne pas apparaître dans l'accueil} other {Certaines données de corbeille n'ont pas pu être supprimées de # fichiers restaurés; ils peuvent ne pas apparaître dans l'accueil}}.",
  trashFoldersPartiallyDeleted:
    "{count, plural, one {# dossier supprimé} other {# dossiers supprimés}} sur {total}. {failed, plural, one {# n'a pas pu être supprimé} other {# n'ont pas pu être supprimés}}.",
  trashFoldersNoLongerInTrash:
    "{count, plural, one {# dossier n'est plus dans la corbeille et a été ignoré} other {# dossiers ne sont plus dans la corbeille et ont été ignorés}}.",
  trashFoldersPartiallyRestored:
    "{count, plural, one {# dossier restauré} other {# dossiers restaurés}} sur {total}. {failed, plural, one {# n'a pas pu être restauré} other {# n'ont pas pu être restaurés}}.",
  errorLoadingTrashMedia:
    "Une erreur s'est produite lors du chargement de la liste des médias de la corbeille.",
  trashFolderRootLoadFailed:
    'Impossible de charger les données du dossier racine pour la corbeille. Veuillez réessayer.',
  trashFolderRootMissing:
    'Dossier racine manquant pour la corbeille. Veuillez réessayer plus tard.',
  trashFolderCreateFailed:
    'Impossible de créer le dossier de la corbeille. Veuillez réessayer.',
  addRedactionCodeDesc: 'ajouter un code de rédaction',
  removeRedactionCodeDesc: 'supprimer un code de rédaction',
  updateRedactionCodeDesc: 'mettre à jour le code de rédaction',
  updateBackgroundBlurLevel: "mettre à jour le niveau de flou d'arrière-plan",
  addBackgroundBlurSlice: "ajouter un segment de flou d'arrière-plan",
  removeBackgroundBlurSlice: "supprimer un segment de flou d'arrière-plan",
  resizeUdr: 'redimensionner UDR',
  addComment: 'ajouter un commentaire',
  updateComment: 'mettre à jour le commentaire',
  removeComment: 'supprimer le commentaire',
  hideComment: 'masquer le commentaire',
  unhideComment: 'afficher le commentaire',
  maskVoiceWords: 'masquer les mots de la voix',
  redactWords: 'rédiger des mots',
  resetWords: 'réinitialiser les mots',
  addAudioRedactionSlice: 'ajouter un segment de rédaction audio',
  addVoiceMaskSlice: 'ajouter un segment de masquage vocal',
  removeVoiceMaskSlice: 'supprimer un segment de masquage vocal',
  removeAudioRedactionSlice: 'supprimer un segment de rédaction audio',
  deleteAudioRedactionNote: 'supprimer la note de rédaction audio',
  updateAudioBuffer: 'mettre à jour le tampon audio',
  deleteAudioBuffer: 'supprimer le tampon audio',
  addRedactionCodeToTranscription:
    'ajouter un code de rédaction à la transcription',
  removeRedactionCodeFromTranscription:
    'supprimer un code de rédaction de la transcription',
  setUdrTimeSpan: "définir la durée de l'UDR",
  adjustUdrTimeSpanOnTimeline: "ajuster la durée de l'UDR sur la timeline",
  stickUdrToVideo: "coller l'UDR à la vidéo",
  hideObjectType: "masquer la {# filterLabel} type d'objet",
  showObjectType: "afficher la {# filterLabel} type d'objet",
  hideAllObjectType: "masquer tous les types d'objets",
  showAllObjectType: "afficher tous les types d'objets",
  updateBackgroundBlurLevels:
    "mettre à jour les niveaux de flou d'arrière-plan",
  selectGroup: 'sélectionner le groupe',
  deselectGroup: 'désélectionner le groupe',
  clearAllMergeSelections: 'désélectionner tous les groupes/segments',
  selectSegmentOnPanel: 'sélectionner le segment',
  deselectSegmentOnPanel: 'désélectionner le segment',
  unredactLowerCase: 'désélectionner',
  redactLowerCase: 'rédiger',
  groupHistoryText: 'groupe',
  segmentHistoryText: 'segment',
  deleteUdrOverlay: 'supprimer la superposition UDR',
  deleteUdrInFrame: "supprimer l'UDR dans la frame",
  deleteDetectionOverlay: 'supprimer {# type} la superposition ',
  deleteDetectionInFrame: 'supprimer {# type} dans la frame',
  deleteUdrGroup: 'supprimer le udr groupe',
  deleteUdrSegment: 'supprimer le udr segment',
  deleteDetectionSegment: 'supprimer {# type} segment',
  deleteDetectionGroup: 'supprimer {# type} groupe',
  removeObjectTypeWhenRedacting:
    "supprimer le type d'objet lors de la rédaction",
  mergeSelected: 'fusionner la sélection',
  resizeOverlaySegment: 'redimensionner le segment de superposition',
  bulkAddBackgroundBlur: "ajouter en masse un flou d'arrière-plan",
  mergedGroupHistoryText: 'groupe fusionné',
  addCustomFillEffect: 'ajouter un effet de remplissage personnalisé',
  updateCustomFillEffect: 'mettre à jour un effet de remplissage personnalisé',
  removeCustomFillEffect: 'supprimer un effet de remplissage personnalisé',
  bulkRemoveCustomFill:
    'Suppression en masse du remplissage personnalisé de {type}',
  bulkAddCustomFill: 'Ajouter en masse du remplissage personnalisé de {type}',
  removeAudioEditSlice: 'supprimer un segment de modification audio',
  redactAllHistory: 'rédiger tout',
  unredactAllHistory: 'désélectionner tout',
  globalSettings: 'Paramètres généraux',
  shortcuts: 'Raccourcis clavier',
  help: 'Aide',
  softDeleteMessage:
    'Ce {entity} sera déplacé vers la corbeille et sera définitivement supprimé après {count, plural, one {# jour} other {# jours}} !',
  file: 'Fichier',
  folder: 'Dossier',
  dateTrashed: 'Date corbeille',
  reviewModeBanner: 'Vous êtes actuellement en mode révision.',
  documentOcrPageFailedHeadline: 'La ROC n’a pas pu lire cette page.',
  documentOcrPageFailedDetail:
    "La recherche par mots-clés n'est pas disponible pour cette page — un examen manuel est recommandé.",
  documentOcrPageRunningHeadline: 'OCR en cours sur cette page',
  documentOcrPageRunningDetail:
    'La recherche sera disponible sur cette page une fois terminée',
  documentOcrPageProcessed: 'Cette page a été traitée par ROC.',
  documentOcrPageProcessedDetail:
    "La sélection de texte, la recherche et la détection d'IIP/de lexique sur les pages numérisées sont effectuées au mieux et peuvent ne pas détecter le texte de faible qualité.",
  documentOcrPageNoTextHeadline:
    'Cette page ne contient aucun texte interrogeable.',
  documentOcrPagePartialHeadline:
    'La ROC n’a pas pu lire une partie de cette page.',
  documentOcrPagePartialDetail:
    'La recherche ne trouvera pas le contenu de ces zones.',
  documentOcrPageNoTextDetail:
    "La recherche par mots-clés n'est pas disponible pour cette page — un examen manuel est recommandé.",
  documentOcrReloadBannerHeadline:
    "L'OCR a terminé le traitement de ce document.",
  documentOcrReloadBannerAction: 'Recharger le document',
  documentOcrRailBadgeLabel: 'Traitée par ROC',
  documentOcrRailFailedLabel: 'La ROC n’a pas pu lire cette page',
  documentOcrRailFailedTitle:
    "La ROC n'a pas pu lire cette page. La recherche par mots-clés n'est pas disponible — un examen manuel est recommandé.",
  documentOcrRailNoTextLabel: 'La page ne contient aucun texte interrogeable',
  documentOcrRailNoTextTitle:
    'Cette page ne contient aucun texte interrogeable.',
  documentOcrRailRunningLabel: 'ROC en cours',
  documentOcrRailReloadPendingLabel: 'ROC terminée',
  documentOcrRailPartialLabel:
    'La ROC n’a pas pu lire une partie de cette page',
  documentOcrRailPartialTitle:
    "La ROC n'a pas pu lire certaines parties de cette page. La recherche par mots-clés ne détectera pas ces sections — un examen manuel est recommandé.",
  documentOcrCaveatHeadlineAll: 'ROC terminée pour toutes les pages.',
  documentOcrCaveatHeadline:
    'OCR terminé pour {count, plural, one {# page} other {# pages}}.',
  documentOcrCaveatDetail:
    'La recherche automatisée et la détection des données personnelles sur les pages numérisées sont effectuées au mieux et peuvent ne pas détecter le texte de faible qualité.',
  documentOcrRunAgainAction: 'Relancer la détection ROC',
  documentOcrFailedHeadline: 'La détection ROC a échoué.',
  documentOcrFailedDetail:
    "Ce document n'a pas été rendu consultable. Relancez-la pour réessayer.",
  documentOcrTimedOutHeadline: 'La détection ROC a expiré.',
  documentOcrTimedOutDetail:
    'Elle ne s\u2019est pas terminée en 24 heures. Relancez-la pour réessayer.',
  documentOcrRunAction: 'Exécuter la détection ROC',
  documentOcrShowRegions: 'Afficher les zones non lues',
  documentOcrHideRegions: 'Masquer les zones non lues',
  documentOcrDetectionChipTitle:
    'Contient des correspondances trouvées dans du texte lu par ROC. La ROC est au mieux approximative; considérez ces résultats comme moins certains que le texte déjà présent dans le document.',
  documentOcrSearchChipTitle:
    'Cette recherche contient {count, plural, one {# correspondance ROC} other {# correspondances ROC}}. La ROC est effectuée au mieux, traitez-la donc comme moins certaine que le texte que le document contenait déjà.',
  documentOcrMatchChipTitle:
    'Ce résultat a été trouvé dans du texte lu par ROC. La ROC est au mieux approximative; considérez-le comme moins certain que le texte déjà présent dans le document.',
  documentOcrRegionUnread: 'Non lu par la ROC',
  documentOcrRegionUncertain: 'Lu avec une faible confiance',
  documentOcrRefreshHeadline: 'OCR terminé.',
  documentOcrRefreshDetail: 'Recherche disponible après actualisation.',
  documentSearchOcrRunning: 'OCR en cours.',
  documentSearchOcrRunningDetail:
    'La recherche par mots-clés sera disponible sur les pages indiquées ci-dessous une fois terminé.',
  documentSearchNoneSearchable: 'Toutes les pages nécessitent la ROC',
  documentSearchSomeUnsearchable:
    '{count, plural, one {# page nécessite} other {# pages nécessitent}} la ROC',
  documentSearchUnsearchableDetail:
    "La recherche par mots-clés n'est pas disponible pour ces pages.",
  railShowOnlyPagesRequiringOcr:
    'Afficher seulement les pages nécessitant la ROC',
  filesTable: 'Tableau des fichiers',
  foldersTable: 'Tableau des dossiers',
  restoreFolderFailed:
    'Échec de la restauration du dossier/de la demande {name}.',
  source: 'Source',
  destination: 'Destination',
  markCommentAsRead: 'marquer le commentaire comme lu',
  filtersAndSorting: 'Filtres & Tri',
  sort: 'Trier',
  newest: 'Plus récent en premier',
  oldest: 'Plus ancien en premier',
  lastSaved: 'Dernier enregistrement:',
  modifiedDate: 'Dernière modification',
  notRedacted: 'Non traité',
  resetFilter: 'Réinitialiser le filtre',
  original: 'Original',
  clickToView: 'Cliquer pour voir',
  resetTranscript: 'Réinitialiser la transcription',
  resetConfirmation: 'Confirmation de réinitialisation',
  resetTranscriptConfirmationDes:
    'Attention ! Êtes-vous sûr de vouloir réinitialiser la transcription ?',
  removeAllAudioRedactions: 'Supprimer toutes les rédactions audio',
  removeAllAudioRedactionsConfirmation: 'Supprimer toutes les rédactions audio',
  removeAllAudioRedactionsConfirmationDes:
    'Êtes-vous sûr de vouloir supprimer toutes les rédactions audio ?',
  removeAllAudioRedactionsHistory: 'supprimer toutes les rédactions audio',
  removeAllVoiceMask: 'Supprimer tout le masquage vocal',
  removeAllVoiceMaskConfirmation: 'Supprimer tout le masquage vocal',
  removeAllVoiceMaskConfirmationDes:
    'Êtes-vous sûr de vouloir supprimer tout le masquage vocal ?',
  removeAllVoiceMaskHistory: 'supprimer tout le masquage vocal',
  deleteTranscription: 'Supprimer la transcription',
  deleteTranscriptionMessage: 'Cela supprimera la transcription actuelle',
  deleteTranscriptionSuccess: 'Transcription supprimée avec succès',
  deleteTranscriptionFailure: 'Échec de la suppression de la transcription',
  deleteTranscriptionHistory: 'supprimer la transcription',

  // Speaker separation (VE-18237). "locuteur" for speaker, matching the
  // established "caviardage" / "moteur" / "soutien" vocabulary used above.
  speakerSeparationTitle: 'Séparation des locuteurs',
  generateSpeakerSeparation: 'Exécuter la séparation des locuteurs',
  speakerView: 'Vue par locuteur',
  separatingSpeakers: 'Séparation des locuteurs en cours…',
  speakerSeparationAlreadyRunning:
    'La séparation des locuteurs est déjà en cours.',
  speakerSeparationFailedShort: 'Échec de la séparation des locuteurs',
  speakerSeparationFailedHint:
    'Le moteur de séparation des locuteurs a échoué. Utilisez le menu Exécuter les moteurs pour réessayer.',
  processSpeakerSeparationSuccess: 'La séparation des locuteurs est prête.',
  processSpeakerSeparationFailed:
    'Séparation des locuteurs {status}. Veuillez réessayer ou contacter le soutien.',
  deleteSpeakerSeparation: 'Supprimer la séparation des locuteurs',
  deleteSpeakerSeparationConfirmationDes:
    'La transcription est conservée, regroupée de nouveau sous un seul locuteur. Vous pourrez relancer la séparation des locuteurs par la suite.',
  deleteSpeakerSeparationSuccess: 'Séparation des locuteurs supprimée',
  deleteSpeakerSeparationFailure:
    'Échec de la suppression de la séparation des locuteurs',
  deleteSpeakerSeparationHistory: 'supprimer la séparation des locuteurs',

  // Audio tab empty state and the Run Engines modal
  runEngines: 'Exécuter les moteurs',
  noEnginesRunMessage: "Aucun moteur n'a encore été exécuté sur cet audio.",
  transcriptionCapability:
    "Convertir la parole en texte afin de pouvoir rechercher et caviarder n'importe quelle partie de l'audio.",
  speakerSeparationCapability:
    'Détecter les changements de locuteur pour améliorer la lisibilité et accélérer les modifications de caviardage.',
  voiceMask: 'Masque vocal',
  voiceMaskCapability:
    "Transformer la voix du locuteur tout en conservant le contenu et l'intonation.",
  alreadyTranscribed:
    "Déjà transcrit. Supprimez la transcription pour l'exécuter de nouveau.",
  alreadyTranscribedPickAnother:
    "Déjà transcrit dans cette langue. Choisissez une autre langue, ou supprimez la transcription pour l'exécuter de nouveau.",
  resetTranscriptHistory: "Réinitialiser l'historique de la transcription",
  documentRedactionRestoreLoadFailed:
    'Impossible de restaurer vos dernières rédactions enregistrées. Vous commencez avec un document vierge.',
  documentRedactionRestoreUnsupportedFormat:
    'Vos rédactions enregistrées utilisent un format plus ancien et n’ont pas pu être restaurées. Vous commencez avec un document vierge.',
  textOverlayTool: "Ajouter un texte à l'écran",
  timelineTextOverlay: "Texte à l'écran",
  textOverlayFilter: 'Texte',
  textOverlayType: 'Texte',
  addTextOverlay: 'Ajouter du texte',
  applyTextOverlay: 'Ajouter du texte',
  editTextOverlay: 'Modifier le texte',
  updateTextOverlay: 'Mettre à jour',
  fullWidth: 'Pleine Largeur',
  width: 'Largeur',

  // --- Lexiques personnalisés (VE-24948 / U5) --------------------------------
  // cspell:words headroom redaction
  // Les trois chaînes csvMessage* sont les traductions des chaînes VERBATIM de
  // U5-FR11 — l'anglais ne doit jamais être reformulé.
  lexicons: 'Lexiques',
  lexiconName: 'Nom du lexique',
  addNewLexicon: 'Ajouter un lexique',
  editLexicon: 'Modifier le lexique',
  lexiconsEmpty:
    'Aucun lexique pour le moment. Créez un lexique de termes et de motifs pour générer des détections.',
  lexiconsNotConfigured:
    "Les lexiques personnalisés ne sont pas encore configurés dans cet environnement. Un administrateur doit provisionner le registre de données des lexiques avant d'utiliser cette page.",
  lexiconMutationBlocked:
    "Votre modification n'a PAS été appliquée : elle n'a pas pu être consignée dans le journal d'audit. Réessayez, ou contactez le soutien si le problème persiste.",
  lexiconMutationAuditIncomplete:
    "Votre modification a été appliquée, mais son enregistrement d'audit est incomplet. Un administrateur pourrait faire un suivi.",
  lexiconMutationFailed: "Votre modification n'a pas été appliquée.",
  lexiconNameRequired: 'Un nom de lexique est requis.',
  lexiconConflictBanner:
    "Quelqu'un d'autre a modifié ce lexique ({modifiedBy}, {modifiedDateTime}). Rechargez pour continuer à partir de sa version.",
  entries: 'Entrées',
  entriesCount: 'Entrées ({count})',
  lexiconEnabledToggle: 'Activer {name}',
  autoApplyLexiconToggle: 'Appliquer automatiquement {name}',
  autoApplyLexiconHint:
    'Inclure automatiquement le lexique dans les résultats IIP.',
  modifiedByActor:
    "Dernier enregistrement par {actor} (tel qu'inscrit sur le lexique; la piste de vérification fait foi)",
  moreActions: 'Plus d’actions',
  lexiconEntriesEmpty:
    'Aucune entrée pour le moment. Ajoutez un mot-clé ou un motif, ou importez un CSV en lot.',
  addEntry: 'Ajouter une entrée',
  editEntry: 'Modifier l’entrée',
  searchEntries: 'Rechercher des entrées',
  lexiconNoMatchingEntries: 'Aucune entrée ne correspond à « {query} ».',
  deletedTermsCount: 'Entrées supprimées ({count})',
  viewDeletedTerms: 'Voir les entrées supprimées ({count})',
  backToEntries: 'Retour aux entrées',
  purgeDeletedTerms: 'Tout purger ({count})',
  purgeDeletedTermsTitle: 'Purger les entrées supprimées',
  purgeDeletedTermsBody:
    'Supprimer définitivement {count, plural, one {# entrée supprimée} other {# entrées supprimées}}? Ils ne pourront plus être restaurés. Les documents déjà caviardés avec eux ne sont pas touchés.',
  purge: 'Purger',
  settingsSubtitleLexicons:
    'Créez des lexiques de termes et de motifs à rechercher dans les documents.',
  uploadCsv: 'Téléverser un CSV',
  importCsvIntro:
    'La première ligne doit être un en-tête nommant les colonnes. L’ordre n’a pas d’importance et les colonnes non reconnues sont ignorées.',
  csvGuideRequired: 'Obligatoire',
  csvGuideYes: 'Oui',
  csvGuideNo: 'Non',
  csvGuideValues: 'Valeurs',
  csvGuideNotes: 'Remarques',
  csvColTerm:
    'Le texte à rechercher, ou l’expression régulière lorsque le type est regex. Mettez entre guillemets un terme contenant une virgule.',
  csvColType:
    'Ce que contient la colonne term : du texte littéral ou une expression régulière.',
  csvColCaseSensitive:
    'Vide signifie false. yes/no et 1/0 fonctionnent aussi. Ignoré pour une expression régulière.',
  csvColWholeWord: 'Vide signifie false. Ignoré pour une expression régulière.',
  csvColRedactionCode:
    'Le code de caviardage à appliquer (code d’affichage); il doit avoir été défini au préalable dans la page de configuration des codes de caviardage. Le code peut aussi être indiqué par son nom avec redaction_code_name (voir ci-dessous).',
  csvColRedactionCodeName:
    'Le nom du code (Code Name) au lieu du code d’affichage. Lu lorsque redaction_code est vide.',
  csvGuideAlternative: 'Facultatif',
  entryType: 'Type',
  entryKindKeyword: 'Mot-clé',
  sortEntries: 'Trier les entrées',
  sortedAZ: 'Trié de A à Z',
  sortedZA: 'Trié de Z à A',
  sortedByDateAdded: 'Trié par date d’ajout',
  entryKindPattern: 'Motif',
  pattern: 'Motif',
  term: 'Terme',
  splitOnCommas: 'Séparer aux virgules',
  splitOnCommasOn: 'ajoute plusieurs termes à la fois',
  splitOnCommasOff: 'ajouté tel quel',
  termEditTip: 'Astuce : ajouté tel quel, virgules comprises.',
  patternInputTip:
    'Astuce : une expression régulière (ECMAScript). Testez-la ci-dessous avant de l’ajouter.',
  patternInputPlaceholder: 'Saisir une expression régulière',
  termInputPlaceholder: 'Mot-clé ou expression',
  caseSensitive: 'Sensible à la casse',
  wholeWord: 'Mot entier',
  redactionCode: 'Code de caviardage',
  redactionCodeDisplay: 'Code de caviardage (affichage)',
  lexiconUnsavedChanges:
    'Vous avez des modifications non enregistrées. Enregistrez ou annulez pour fermer.',
  redactionCodeOptional: 'Code de caviardage (facultatif)',
  entryCodeLabel: 'Code : {code}',
  lexiconTermTooLong: 'Chaque terme doit compter au plus {max} caractères.',
  lexiconHeadroom: 'Ce lexique peut recevoir encore {headroom} entrées.',
  importCsv: 'Importer un CSV',
  importCsvTitle: "Importer des entrées d'un CSV",
  chooseCsvFile: 'Choisir un fichier CSV',
  csvValidating: 'Vérification du fichier…',
  csvErrorSummary:
    '{count, plural, one {# erreur doit être corrigée} other {# erreurs doivent être corrigées}} avant de pouvoir importer ce fichier.',
  csvOkSummary:
    '{count, plural, one {# entrée prête} other {# entrées prêtes}} à importer.',
  csvSkippedSummary:
    '{skipped, plural, one {# entrée déjà présente} other {# entrées déjà présentes}} dans ce lexique seront ignorées.',
  row: 'Ligne',
  column: 'Colonne',
  problem: 'Problème',
  import: 'Importer',
  regexSampleText: "Texte d'exemple à tester",
  test: 'Tester',
  regexTestRunning: 'Test en cours…',
  regexTestTooSlow:
    "Ce motif a été trop lent pour se terminer sur le texte d'exemple; il serait donc abandonné sur un document réel. Simplifiez-le avant d'enregistrer.",
  regexTestFailed: "Le motif n'a pas pu être testé. Réessayez.",
  regexTestMatches:
    "{count, plural, =0 {Aucune correspondance dans le texte d'exemple.} one {# correspondance.} other {# correspondances.}}",
  rename: 'Renommer',
  reload: 'Recharger',
  deleteLexiconTitle: 'Supprimer « {name} » ?',
  deleteLexiconBody:
    "Les documents déjà caviardés avec ce lexique ne sont pas affectés, mais il ne peut plus être appliqué à d'autres documents. Vous pouvez le restaurer, ou le supprimer définitivement, depuis la page Lexiques supprimés.",
  deletedLexicons: 'Lexiques supprimés',
  backToLexicons: 'Retour aux lexiques',
  viewDeletedLexicons: 'Voir les lexiques supprimés ({count})',
  deletedLexiconsEmpty: 'Aucun lexique supprimé.',
  lexiconNameTaken: 'Un lexique portant ce nom existe déjà.',
  lexiconNameTooLong:
    'Un nom de lexique doit compter au plus {max} caractères.',
  permanentlyDeleteLexiconAria: 'Supprimer définitivement {name}',
  permanentlyDeleteLexiconTitle: 'Supprimer définitivement « {name} » ?',
  permanentlyDeleteLexiconBody:
    'Les documents déjà caviardés avec ce lexique ne sont pas affectés. Le lexique et toutes ses entrées sont supprimés définitivement et ne peuvent pas être restaurés.',
  noRecordsFound: 'Aucun résultat',
  // Chaînes U5-FR11 (traductions des chaînes verbatim) :
  csvMessageInvalidRegex:
    'Expression régulière invalide, corrigez-la et réessayez votre téléversement',
  csvMessageDuplicate: 'Valeurs en double',
  csvMessageUnknownCode:
    'Code de caviardage non disponible, ajoutez le code dans la page des codes de caviardage',
  applyLexicons: 'Appliquer des lexiques',
  applyLexiconTrigger: 'Appliquer un lexique',
  lexiconPanelHelp:
    'Sélectionnez un ou plusieurs lexiques pour analyser ce document. Les correspondances apparaissent ci-dessous comme détections.',
  lexiconsAllApplied: 'Tous les lexiques sont déjà appliqués à ce document.',
  lexiconApplyAgain: 'Appliquer de nouveau',
  lexiconRemoveFromDocument:
    'Retirer {name} de ce document au moment d’appliquer — {removed, plural, one {# correspondance non caviardée est retirée} other {# correspondances non caviardées sont retirées}}, {kept} caviardées sont conservées. Annuler le rétablit.',
  lexiconRemoveFromDocumentAria: 'Retirer {name} de ce document',
  lexiconsEmptyInEditor:
    'Aucun lexique pour le moment. Créez-en un dans Paramètres \u2192 Lexiques.',
  lexiconEntryCount: '{count, plural, one {# entrée} other {# entrées}}',
  lexiconsWillBeApplied:
    "{count, plural, one {# lexique sera appliqué} other {# lexiques seront appliqués}} à l'ouverture de chaque document.",
  appliedLexicons: 'Appliqués à ce document',
  lexiconPendingEvaluation: 'en attente',
  lexiconEntryDuplicate:
    '{count, plural, one {Cette entrée est déjà} other {Ces entrées sont déjà}} dans ce lexique.',
  lexiconAwaitingText:
    "En attente du texte du document — la recherche s'exécutera à mesure que les pages deviennent disponibles.",
  lexiconApplyDone:
    '{matches, plural, =0 {Aucune correspondance trouvée.} one {# correspondance trouvée.} other {# correspondances trouvées.}}',
  detectionOriginLexicon: 'Lexique',
  lexiconApplyTimedOut:
    'La recherche s’est arrêtée à la limite de temps — les résultats peuvent être incomplets.',
  lexiconApplyWorkerFailed:
    'Le moteur de recherche s’est arrêté de façon inattendue avant la fin; les résultats sont donc incomplets. Rechargez la page et réessayez; si le problème persiste, signalez-le — il ne vient pas de votre lexique.',
  lexiconApplyPagesNotSearched:
    '{count, plural, one {La page {pages} n’a pas été recherchée.} other {Les pages {pages} n’ont pas été recherchées.}}',
  lexiconApplyAlreadyPresent:
    'Déjà appliqué — {matches, plural, one {# correspondance est} other {# correspondances sont}} sur ce document.',
  lexiconApplyAllAdopted:
    '{matches, plural, one {# correspondance avait} other {# correspondances avaient}} déjà été masquée(s) manuellement et a/ont été adoptée(s).',
  lexiconApplyAllDismissed:
    "{matches, plural, one {# correspondance avait} other {# correspondances avaient}} été écartée(s) et n'est/ne sont pas rajoutée(s).",
  lexiconApplyMatchesNotPlaced:
    "{count, plural, one {# correspondance a été trouvée mais n'a pas pu être positionnée sur la page} other {# correspondances ont été trouvées mais n'ont pas pu être positionnées sur la page}} — ouvrez de nouveau le document pour réessayer.",
  lexiconApplyNoMatches: 'Aucune correspondance trouvée.',
  lexiconAppliedIncomplete: 'incomplet',
  lexiconAppliedIndexing: 'indexation',
  lexiconAppliedIndexingDetail:
    "Appliqué pendant l'indexation du document. Les pages restantes seront recherchées à la fin de l'indexation.",
  lexiconApplyIndexFailedPagesUnknown:
    "Le document n'a pas pu être entièrement indexé; certaines pages n'ont donc pas été recherchées. Rouvrez le document, puis appliquez de nouveau.",
  lexiconApplyIndexFailedReopen:
    "Le document n'a pas pu être entièrement indexé; une nouvelle application ne comblera donc pas ces pages. Rouvrez le document, puis appliquez de nouveau.",
  lexiconApplyStillIndexing:
    "Le document est encore en cours d'indexation — les pages restantes seront recherchées à la fin.",
  lexiconAppliedIncompleteDetail:
    "Cette application ne s'est pas terminée{cause, select, timedOut { — la limite de temps a été atteinte} workerFailed { — le moteur de recherche s'est arrêté de façon inattendue} indexFailed { — le document n'a pas pu être entièrement indexé; certaines pages n'ont donc pas été recherchées} other {}}. Entrées non évaluées : {entries}. Correspondances non positionnées : {matches}.{pages, select, none {} other { Page(s) non recherchée(s) : {pages}.}}{cause, select, indexFailed { Rouvrez le document, puis appliquez de nouveau.} other { Appliquez de nouveau pour la terminer.}}",
  lexiconApplyEmptyLexicon:
    "{count, plural, one {Le lexique appliqué ne contient} other {Les lexiques appliqués ne contiennent}} aucune entrée; il n'y avait donc rien à rechercher. Ajoutez des entrées dans la page des lexiques.",
  lexiconApplyFailed: "L'application des lexiques a échoué. Réessayez.",
  lexiconApplyIndexFailedNoText:
    "Le document n'a pas pu être indexé; il n'y avait donc rien à rechercher. Rouvrez le document, puis appliquez de nouveau.",
  lexiconNoExtractableText:
    "Ce document ne contient aucun texte à rechercher; les lexiques ne peuvent donc pas y être appliqués. Un document numérisé doit d'abord passer par la ROC.",
  lexiconUnreachable:
    "Impossible de charger l'un des lexiques sélectionnés; rien n'a donc été appliqué. Rien n'a changé dans ce document — réessayez.",
  lexiconAbandonedEntries:
    "{count, plural, one {# entrée n'a pas pu être évaluée} other {# entrées n'ont pas pu être évaluées}}.",
  lexiconAbandonedEntriesInLexicons:
    "{count, plural, one {# entrée n'a pas pu être évaluée} other {# entrées n'ont pas pu être évaluées}}, dans : {lexicons}.",
  lexiconAbandonedEntriesDetail:
    "Une entrée est ignorée lorsque son motif est illisible, ou lorsqu'elle épuise la part de temps que la recherche lui accorde — presque toujours une expression régulière qui revient sur ses pas. Ce qu'elle avait déjà trouvé est conservé; les pages qu'elle n'avait pas encore atteintes n'ont pas été recherchées pour elle. Simplifiez l'entrée dans les paramètres des lexiques, puis appliquez de nouveau.",
  lexiconApplyProgressMatches:
    "{matches, plural, one {# correspondance} other {# correspondances}} jusqu'ici",
  lexiconApplyProgressPages:
    '({pages, plural, one {# page vérifiée} other {# pages vérifiées}})',
  // --- Filigranes (VE-24693) ---------------------------------------------
  // This catalogue already says « caviarder » for redaction, so a watermark is
  // a « filigrane » apposed on a « fichier caviardé ». Same register as the rest
  // of the file: vouvoiement, and « téléverser » rather than the France-French
  // « uploader ».
  watermarks: 'Filigranes',
  permanentlyDelete: 'Supprimer définitivement',
  watermarkEnabledToggle: 'Activer {name}',
  viewDeletedWatermarks: 'Voir les filigranes supprimés ({count})',
  backToWatermarks: 'Retour aux filigranes',
  watermark: 'Filigrane',
  addNewWatermark: 'Ajouter un filigrane',
  addNewWatermarkTitle: 'Ajouter un filigrane',
  text: 'Texte',
  // "Aperçu", the noun. `preview` is 'Prévisualiser', the verb, and belongs on
  // a button rather than a column heading.
  watermarkPreview: 'Aperçu',
  dateModified: 'Date de modification',
  addWatermark: 'Ajouter un filigrane',
  addWatermarkOption: '+ Ajouter un filigrane',
  editWatermark: 'Modifier le filigrane',
  deleteWatermark: 'Supprimer le filigrane',
  // VE-24447 Bates stamping.
  batesStamping: 'Apposition de numéros Bates',
  configureBatesStamping: 'Configurer l’apposition de numéros Bates',
  batesNumberOfDigits: 'Chiffres',
  batesStartNumberingFrom: 'Début #',
  batesPrefix: 'Préfixe',
  batesPlacement: 'Position (en-tête / pied de page)',
  batesSuffix: 'Suffixe',
  batesFontSize: 'Taille (pt)',
  batesBold: 'Gras',
  batesBoldTooltip:
    'Afficher le numéro en gras — plus lisible sur une numérisation sombre ou bruitée.',
  batesShade: 'Teinte',
  batesShadeTooltip: 'Teinte du tampon — du noir au gris clair.',
  batesMarginSides: 'Gauche/droite (po)',
  batesMarginEnds: 'Haut/bas (po)',
  batesMarginLink: 'Lier les marges',
  batesMarginLinkOn:
    'Les deux marges bougent ensemble. Cliquez pour les régler séparément.',
  batesMarginLinkOff:
    'Les marges sont réglées séparément. Cliquez pour les faire bouger ensemble.',
  batesFirstPagePreview: 'Aperçu',
  batesTooltipIdle:
    'Apposition de numéros Bates — numéroter chaque page du fichier caviardé',
  batesTooltipActive:
    'Apposition de numéros Bates — appliquée; chaque page du fichier caviardé est numérotée',
  batesSwitchTooltipOn:
    'L’apposition de numéros Bates est activée — la page affiche un aperçu. « Appliquer » la place sur chaque page du fichier exporté.',
  batesSwitchTooltipOff:
    'L’apposition de numéros Bates est désactivée — rien n’est dessiné et vos réglages sont conservés. « Appliquer » laisse le document sans numérotation.',
  batesPreviewPendingApply: 'Aperçu seulement — pas encore appliqué.',
  batesPreviewPendingRemove:
    'Aperçu seulement — « Appliquer » masque les numéros Bates.',
  batesPreviewPendingAdd:
    'Aperçu seulement — « Appliquer » ajoute les numéros Bates.',
  batesPreviewPendingRestore:
    'Aperçu seulement — « Appliquer » rétablit les numéros Bates.',
  batesPreviewOff:
    'L’apposition de numéros Bates est désactivée pour ce document.',
  batesTurnedOff:
    'L’apposition de numéros Bates est désactivée. Utilisez le bouton ci-dessus pour l’activer.',
  batesPreviewApplied: 'Ces réglages sont appliqués à ce document.',
  batesPreviewNone: 'Ce document n’est pas numéroté.',
  batesUnsupportedCharacters:
    'Ces caractères ne peuvent pas être imprimés sur le tampon : {chars}',
  watermarkUnsupportedCharacters:
    'Ces caractères ne peuvent pas être imprimés sur le filigrane : {chars}',
  watermarkSwitchTooltipOn:
    'Les filigranes sont activés — la page affiche un aperçu. « Appliquer » les appose sur le fichier exporté.',
  watermarkSwitchTooltipOff:
    'Les filigranes sont désactivés — rien n’est dessiné et vos marques sont conservées. « Appliquer » laisse le document sans marque.',
  watermarkPreviewPendingApply: 'Aperçu seulement — pas encore appliqué.',
  watermarkPreviewPendingHide:
    'Aperçu seulement — « Appliquer » masque les filigranes.',
  watermarkPreviewPendingRestore:
    'Aperçu seulement — « Appliquer » rétablit les filigranes.',
  watermarkPreviewOff:
    'Les filigranes sont désactivés pour ce document. Ils sont conservés, mais ni affichés ni incrustés.',
  watermarkPreviewApplied: 'Ces réglages sont appliqués à ce document.',
  watermarkPreviewNone: 'Ce document n’a aucun filigrane.',
  configureWatermark: 'Configurer le filigrane',
  watermarkNameTaken: 'Un filigrane portant ce nom existe déjà.',
  // Same set as en-US — see the note there. These had no French at all, so the
  // drawer and the editor panel were showing English inside a French session.
  bold: 'Gras',
  style: 'Style',
  align: 'Alignement',
  custom: 'Personnalisé',
  loading: 'Chargement…',
  done: 'Terminé',
  opacity: 'Opacité',
  grayscale: 'Niveaux de gris',
  textColor: 'Couleur du texte',
  freeText: 'Texte libre',
  clickOrDragImage: 'Cliquez pour téléverser ou glissez une image ici',
  dropImageHere: 'Déposez l’image ici',
  alignMultilineOnly: 'S’applique au texte à plusieurs lignes',
  positionOnScreen: 'Position à l’écran',
  insetFromEdge: 'Retrait depuis le bord',
  addWatermarkLine: 'Ajouter une ligne',
  removeWatermarkLine: 'Supprimer la ligne {number}',
  restoreWatermarkDefaults: 'Rétablir les valeurs par défaut',
  dragWatermarkHint:
    'Cliquez sur le filigrane et faites-le glisser pour le repositionner.',
  largePreview: 'Grand aperçu',
  viewLargePreview: 'Afficher le grand aperçu',
  hideLargePreview: 'Masquer le grand aperçu',
  uploadSampleDocument: 'Téléverser un document exemple',
  sampleDocumentHint:
    'PDF ou image, utilisé uniquement pour cet aperçu et jamais enregistré.',
  previousPage: 'Page précédente',
  nextPage: 'Page suivante',
  pageXofY: 'Page {page} sur {total}',
  watermarkArtworkMissingRow:
    "L'image de ce filigrane est introuvable : il n'apparaîtra pas dans le fichier exporté. Supprimez-le puis appliquez-le de nouveau.",
  watermarkArtworkUnavailable:
    'L’image de ce filigrane n’a pas pu être chargée; il n’a donc pas été appliqué.',
  rotation: 'Rotation',
  autoApply: 'Application auto',
  autoApplyWatermark:
    'Appliquer automatiquement le filigrane à tous les nouveaux médias',
  autoApplyWatermarkToggle: 'Appliquer automatiquement {name}',
  autoApplyWatermarkHint:
    "Appliqué à la première ouverture d'un nouveau fichier.",
  textSize: 'Taille du texte',
  textOpacity: 'Opacité du texte',
  imageScale: "Échelle de l'image",
  watermarkScale: 'Échelle',
  watermarkOpacity: 'Opacité',
  imageOpacity: "Opacité de l'image",
  originalImage: "Image d'origine",
  deletedWatermarks: 'Filigranes supprimés',
  nameOfWatermark: 'Nom du filigrane',
  watermarkText: "Texte d'affichage",
  deleteWatermarkTitle: 'Supprimer « {name} » ?',
  deleteWatermarkStillDisplayedNote:
    'Les fichiers qui utilisent actuellement ce filigrane continueront de ' +
    "l'afficher, mais il ne pourra plus être appliqué à d'autres fichiers. " +
    'Vous pouvez supprimer définitivement ce filigrane depuis la page ' +
    'Filigranes supprimés.',
  permanentlyDeleteWatermarkTitle: 'Supprimer définitivement « {name} » ?',
  permanentlyDeleteWatermarkNote:
    'Les fichiers qui utilisent actuellement ce filigrane continueront de ' +
    "l'afficher. Le filigrane lui-même est supprimé définitivement et ne " +
    'pourra pas être restauré.',
  noWatermarksYet:
    "Aucun filigrane pour l'instant. Téléversez une image ou créez-en un à partir de texte.",
  noWatermarksInLibrary:
    "Aucun filigrane pour l'instant — créez-en un dans la page de paramètres Filigranes.",
  noWatermarksAddedYet:
    "Aucune marque ajoutée. Choisissez-en une ci-dessus pour l'apposer sur le document — ajoutez-en autant que nécessaire.",
  watermarkAlreadyAdded: '{name} (ajouté)',
  removeWatermarkNamed: 'Retirer {name}',
  clone: 'Cloner',
  importExistingProfile: 'Importer un profil existant',
  seededFromProfile: 'Paramètres initiaux copiés du profil : {name}',
  deleteRedactionCodeTitle: 'Supprimer « {name} » ?',
  permanentlyDeleteRedactionCodeTitle: 'Supprimer définitivement « {name} » ?',
  deleteProfileTitle: 'Supprimer « {name} » ?',
  permanentlyDeleteProfileTitle: 'Supprimer définitivement « {name} » ?',
  profileNoLongerAvailable: "Ce profil n'est plus disponible.",
  redactionCodeNoLongerAvailable:
    "Ce code de caviardage n'est plus disponible.",
  redactionCodeDeleted: 'Code de caviardage supprimé.',
  redactionCodeRestored: 'Code de caviardage restauré.',
  backToRedactionCodes: 'Retour aux codes de caviardage',
  deletedRedactionCodes: 'Codes de caviardage supprimés',
  viewDeletedRedactionCodes: 'Voir les codes supprimés ({count})',
  redactionCodeNameTaken: 'Un code portant ce nom existe déjà.',
  permanentlyDeleteRedactionCode:
    'Supprimer définitivement le code de caviardage',
  permanentlyDeleteRedactionCodeAria: 'Supprimer définitivement {name}',
  permanentlyDeleteRedactionCodeMessage:
    'Ce code sera supprimé définitivement et ne pourra pas être restauré. Les fichiers déjà caviardés n’en conserveront que le texte. Continuer ?',
  deleteRedactionCodeMessage:
    'Ce code sera retiré de la liste et des sélecteurs de codes. Vous pourrez le restaurer plus tard depuis la vue des codes supprimés.',
  backToProfiles: 'Retour aux profils',
  deletedProfiles: 'Profils supprimés',
  viewDeletedProfiles: 'Voir les profils supprimés ({count})',
  profileNameTaken: 'Un profil portant ce nom existe déjà.',
  permanentlyDeleteProfile: 'Supprimer définitivement le profil',
  permanentlyDeleteProfileAria: 'Supprimer définitivement {name}',
  permanentlyDeleteProfileMessage:
    'Ce profil sera supprimé définitivement et ne pourra pas être restauré. Continuer ?',
  deleteProfileMessage:
    'Ce profil sera retiré de la liste. Vous pourrez le restaurer plus tard depuis la vue des profils supprimés.',
  profileRowActions: 'Actions pour {name}',
  watermarkRowActions: 'Actions pour {name}',
  watermarkTooltipActive:
    'Filigranes — ajuster les marques apposées sur le fichier caviardé',
  watermarkTooltipIdle:
    'Filigranes — apposer un filigrane enregistré sur le fichier caviardé',
  watermarkOpacityHint: 'Maximum {max} % afin de garder le contenu lisible.',
  watermarkBwHint: "Supprime la couleur de l'image d'origine",
  watermarkNameRequired: 'Le nom est obligatoire.',
  watermarkTextRequired: 'Le texte du filigrane est obligatoire.',
  watermarkImageRequired: 'Veuillez téléverser une image.',
  watermarkImageHint:
    'Formats acceptés : .svg, .png, .jpg · Taille maximale : {limit}.',
  addWatermarkToDocs:
    'Appliquer le ou les filigranes sélectionnés à {count} document(s).',
  batchWatermarkProgress: 'Ajout du filigrane à {count}…',
  batchWatermarkSuccess: 'Filigrane ajouté à {count} fichiers.',
  batchWatermarkFailure: "{count} fichiers n'ont pas pu être mis à jour.",
  watermarkImageRestoreFailed:
    "{count, plural, one {Une image de filigrane n'a pas pu être restaurée et n'apparaîtra pas} other {# images de filigrane n'ont pas pu être restaurées et n'apparaîtront pas}} dans le fichier exporté.",
  settingsSubtitleRedactionCodes:
    "Codes indiquant la raison d'un caviardage, affichés par-dessus celui-ci dans les vidéos, les images et les documents. Certaines juridictions l'exigent.",
  settingsSubtitleStatuses:
    'États du flux de travail des fichiers, avec verrouillage facultatif de la modification.',
  settingsSubtitleProfiles:
    'Ensembles réutilisables de paramètres de traitement et de caviardage par défaut, appliqués aux nouveaux fichiers.',
  settingsSubtitleWatermarks:
    'Bibliothèque partagée de filigranes à appliquer aux documents.',
  settingsSubtitleTrash:
    'Éléments placés dans la corbeille. Restaurez-les ou supprimez-les définitivement ici; tout élément restant est supprimé automatiquement à la fin de la période de conservation.',
  watermarkLibraryUnavailableTitle:
    'Les filigranes ne sont pas encore configurés',
  watermarkLibraryUnavailableBody:
    "Le stockage partagé des filigranes n'est pas encore configuré pour votre organisation. Ils ne peuvent donc pas être créés ni modifiés ici. Communiquez avec votre administrateur.",
  fetchWatermarksFailure:
    "Une erreur inattendue s'est produite lors de la récupération des filigranes.",
  createWatermarkFailure:
    "Une erreur inattendue s'est produite lors de la création du filigrane.",
  updateWatermarkFailure:
    "Une erreur inattendue s'est produite lors de la mise à jour du filigrane.",
  deleteWatermarkFailure:
    "Une erreur inattendue s'est produite lors de la suppression du filigrane.",

  // /admin — administration de l'instance (VE-27257)
  adminPageTitle: 'Administration',
  adminPageSubtitle:
    "Administration de Redact au niveau de l'instance. Les actions de ces pages touchent l'environnement entier, et non une seule organisation.",
  adminToolNeedsRootOrg:
    "Vous devez être dans l'organisation racine de l'instance pour ouvrir ceci.",
  adminToolAppConfigBody:
    "Comparer les définitions de configuration enregistrées dans cet environnement avec les valeurs par défaut d'usine, puis les enregistrer, les mettre à jour ou les supprimer.",
  adminToolDependenciesTitle: 'Vérification des registres de données',
  adminToolDependenciesBody:
    'Vérifier que chaque registre de données aiWARE dont Redact dépend existe et possède un schéma publié. Lecture seule.',
  adminAppConfigTitle: "Configuration de l'application",
  adminAppConfigSubtitle:
    "Configurez les valeurs par défaut de la configuration de l'application pour toutes les organisations.",
  adminAppConfigSubtitleOrg:
    "Pour remplacer un paramètre pour une organisation donnée, utilisez la page Paramètres de configuration de l'application (bientôt disponible).",
  adminRootOrgConfirmed:
    "Vous êtes dans l'organisation racine de l'instance — les modifications de définitions y sont permises.",
  adminRootOrgUnknownTitle:
    "Impossible de confirmer s'il s'agit de l'organisation racine",
  adminRootOrgUnknownBody:
    "Les commandes restent activées. Si une modification est refusée, le message d'erreur de l'API s'affiche sur la ligne concernée.",

  // /admin/app-config — synchronisation des définitions de configuration (VE-27257)
  adminConfigDefinitionsTitle: "Configuration de l'application",
  adminAppId: "ID de l'application",
  adminScopeExplainer:
    "Les définitions s'appliquent à tout l'environnement et sont la seule chose que cette page écrit. Les valeurs d'organisation sont lues pour votre propre organisation et ne sont jamais écrites.",
  adminScannedAt: 'Analysé à {time}',
  adminScan: 'Analyser',
  adminScanTooltip: 'Réanalyser cet environnement',
  adminRetryScan: "Relancer l'analyse",
  adminScanning: 'Lecture des définitions de cet environnement…',
  adminScanFailedTitle:
    'Impossible de lire les définitions de cet environnement',
  adminAllInSync:
    "Les {count} définitions correspondent aux valeurs par défaut d'usine, clés développeur comprises. Rien de manquant, de différent, d'obsolète ni de non reconnu.",
  adminAddAllMissing: 'Ajouter tout ce qui manque ({count})',
  adminTabAll: 'Toutes',
  adminSortBy: 'Trier par',
  adminSortByName: 'Nom',
  adminSortByCategory: 'Catégorie',
  adminBucketEmpty: 'Rien dans cette catégorie.',
  adminCustomValue: 'Valeur personnalisée',
  adminCustomValueWith: 'Personnalisée : {value}',
  adminUserLevel: 'Niveau utilisateur',
  adminViewOptions: "Options d'affichage",
  adminShowDeveloperSection: 'Afficher les options de développement',
  adminShowOrgSettings: "Afficher les paramètres actuels de l'organisation",
  adminTabAllBlurb:
    "Toutes les clés attendues dans cet environnement, plus tout ce qui est enregistré sans figurer dans une liste. Les options de développement n'y sont jamais comptées.",
  adminTabStandard: 'Standard',
  adminTabStandardBlurb:
    'Attendues dans tous les environnements. Ce sont les paramètres le plus souvent personnalisés pour une organisation donnée.',
  adminStateAll: 'Toutes',
  adminTabAdvanced: 'Avancé',
  adminTabAdvancedBlurb:
    'Attendues dans tous les environnements elles aussi. En général, il ne faut pas y toucher une fois initialisées, à moins de savoir ce que vous faites.',
  adminTabDeveloper: 'Développeur',
  adminTabDeveloperBlurb:
    'Enregistrées uniquement à dessein. Un environnement sans elles fonctionne comme prévu; une clé absente affiche donc « Non enregistrée » plutôt que « Manquante ».',
  adminCustomValueFilter: 'Valeur personnalisée ({count})',
  adminNoCustomValues: "Cette organisation n'a remplacé aucune clé.",
  adminFieldsDifferCount:
    '{count, plural, one {# champ diffère} other {# champs diffèrent}}',
  adminShowDetailsDrift:
    'Afficher les détails ({count} champ{count, plural, one {} other {s}} diffère{count, plural, one {} other {nt}})',
  adminShowDetails: 'Afficher les détails',
  adminHideDetails: 'Masquer les détails',
  adminInSyncTick: "Disponible et utilise la valeur par défaut d'usine",
  adminChangedFromFactory: "Modifié par rapport à la valeur par défaut d'usine",
  adminColumnName: 'Nom',
  adminColumnType: 'Type',
  adminColumnFactoryDefault: "Valeur par défaut d'usine",
  adminColumnEnvironmentDefault:
    "Valeur par défaut de l'environnement / Installation",
  adminDetailField: 'Champ',
  adminShowAllFields: 'Afficher tous les champs',
  adminShowFewerFields: 'Afficher moins de champs',
  adminJsonDefaultEmpty:
    "Un objet vide et aucune valeur par défaut expriment la même chose : la plateforme renvoie un objet vide pour un defaultValueJSON que personne n'a défini, donc ce n'est pas signalé comme une modification.",
  adminJsonDefaultImmaterial:
    "defaultValueJSON diffère, mais cette définition n'est pas de type JSON — rien ne lit cette colonne, ce n'est donc pas signalé comme une désynchronisation.",
  adminOrgValuesUnavailable:
    "Les valeurs de cette organisation n'ont pas pu être lues; la page ne peut donc pas indiquer si cette clé est remplacée.",
  adminValuesUnavailableMeta:
    "Les valeurs de cette organisation n'ont pas pu être lues — les indicateurs de valeur personnalisée ne sont pas disponibles.",
  adminBucketMissing: 'Manquantes',
  adminNotRegistered: 'Non enregistrée',
  adminBucketMissingBlurb:
    "Possède une valeur par défaut d'usine, mais n'est pas enregistrée dans cet environnement.",
  adminBucketInSync: 'Prêt',
  adminBucketDrifted: 'Modifié',
  adminBucketDriftedBlurb:
    "Enregistrées, mais la définition ne correspond pas à la valeur par défaut d'usine.",
  adminBucketDeprecatedShort: 'Obsolètes',
  adminBucketDeprecatedBlurb:
    "Retirées des valeurs par défaut d'usine, et toujours enregistrées ici.",
  adminBucketUnrecognized: 'Non reconnues',
  adminBucketUnrecognizedBlurb:
    "Enregistrées ici, mais absentes des deux listes — il peut s'agir d'une clé oubliée dans nos valeurs par défaut d'usine. Supprimez-les une à la fois.",
  adminConfirmAddTitle:
    'Enregistrer {count} définition{count, plural, one {} other {s}} ?',
  adminConfirmAddAction: 'Enregistrer',
  adminConfirmAddBody:
    "Ceci s'applique à l'environnement entier, et non à une seule organisation. Chaque valeur par défaut ci-dessous devient le comportement de toutes les organisations, sauf celles ayant défini leur propre valeur.",
  adminConfirmAddPrecedence:
    "L'enregistrement change aussi la source qui décide : une définition enregistrée a préséance sur la même clé dans la configuration featureFlags. Un environnement qui désactivait une fonctionnalité de cette façon la verra réactivée.",
  adminConfirmAddNoDefaults:
    "{count} d'entre elles ne déclarent aucune valeur par défaut et ne changent rien à elles seules.",
  adminBucketInSyncBlurb:
    "Enregistrées et conformes à la valeur par défaut d'usine. Rien à faire — à supprimer uniquement pour annuler un enregistrement.",
  adminDeleteInSyncTitle:
    "Retirer une définition attendue par les valeurs par défaut d'usine ?",
  adminDeleteInSyncBody:
    "Les valeurs par défaut d'usine attendent que {configKey} soit enregistrée, et elle correspond actuellement. La retirer sort la définition de tout l'environnement.",
  adminDeleteInSyncConsequence:
    "L'application revient à sa propre valeur par défaut pour cette clé, toute valeur définie par une organisation contre cette définition est supprimée avec elle, et la prochaine analyse signalera la clé comme manquante. Faites-le pour annuler un enregistrement, non pour désactiver une fonctionnalité — pour cela, définissez plutôt la valeur.",
  adminDuplicateKeys:
    'Enregistrées plus d’une fois : {keys}. La première de chacune est affichée.',
  adminDismissError: 'Ignorer',
  adminErrorNotWritten:
    "L'API a répondu sans confirmer la modification ; celle-ci n'a donc pas pris effet.",
  adminErrorNoConfirmation:
    "L'API n'a retourné aucune confirmation ; rien n'a été modifié. La définition appartient peut-être à une autre organisation, ou n'existe pas pour la vôtre.",
  adminErrorDeleteRefused: "L'environnement a refusé la suppression.",
  adminErrorScanUnknown: "La requête a échoué sans message d'erreur.",
  adminErrorScanTruncated:
    "Arrêt après {pages} pages et {count} définitions lues : cet environnement en contient plus que l'analyse ne peut afficher. Rapporter une analyse partielle signalerait comme manquantes des clés déjà enregistrées.",
  adminErrorCreateFailed: "Les définitions n'ont pas pu être enregistrées.",
  adminErrorUpdateFailed: "La définition n'a pas pu être mise à jour.",
  adminErrorDeleteFailed: "La définition n'a pas pu être supprimée.",
  adminDriftNotUpdatable:
    "La mise à jour ne peut pas corriger ceci : l'API ignore {fields} lorsque la valeur est false, vide ou en cours d'effacement, et signale tout de même un succès. Modifiez-le directement dans la plateforme.",
  adminErrorNotRegistered:
    "L'API n'a pas signalé l'enregistrement de cette clé. Le plus souvent, elle est déjà enregistrée — relancez l'analyse pour voir l'état actuel.",
  adminSecuredValueHidden: 'masqué (sécurisé)',
  adminNoDefault: 'aucune',
  adminRegistered: 'Ajouté',
  adminUpdated: 'Mise à jour',
  adminDeleted: 'Supprimée',
  adminAdd: 'Ajouter',
  adminAdding: 'Ajout en cours…',
  adminAddFailed: "Échec de l'ajout",
  adminRetry: 'Réessayer',
  adminUpdate: "Rétablir le paramètre d'usine",
  adminUpdating: 'Rétablissement…',
  adminUpdateFailed: 'Échec de la mise à jour',
  adminExpectedManifest: "Valeur par défaut d'usine",
  adminActualEnvironment: "Valeur par défaut de l'environnement",
  adminDelete: 'Supprimer',
  adminEditDefault: 'Modifier le paramètre…',
  adminEditDefaultTitle: 'Définir la valeur par défaut de {configKey}',
  adminEditDefaultAction: 'Définir',
  adminScanTooltipAt: 'Réanalyser cet environnement (dernière lecture {time})',
  adminEditDefaultSecured:
    "Cette définition est marquée comme sécurisée : sa valeur n'est pas affichée ici, et une valeur par défaut choisie sans voir l'actuelle est un écrasement à l'aveugle. Modifiez-la directement dans la plateforme.",
  adminOrgSettingLabel: "PARAMÈTRE DE L'ORGANISATION :",
  adminOrgSettingCustom: 'personnalisé',
  adminOrgSettingDefault: "utilise la valeur par défaut de l'environnement",
  adminEditDefaultCurrent: "Valeur par défaut actuelle de l'environnement",
  adminEditDefaultManifest: 'Valeur par défaut d’usine',
  adminEditDefaultNew: 'Nouvelle valeur par défaut',
  adminEditDefaultInvalidJson: 'JSON non valide.',
  adminEditDefaultConsequenceUnknown:
    "Ce comportement s'appliquera à toutes les organisations qui n'ont pas défini leur propre valeur. Aucune valeur par défaut d'usine ne décrit cette clé : rien ici ne peut vous dire si la valeur est la bonne.",
  adminEditDefaultConsequence:
    "Ceci devient le comportement de toutes les organisations, sauf celles ayant défini leur propre valeur. La clé différera alors de la valeur par défaut d'usine, et cette page continuera de la signaler sous « Diffère » avec une mise à jour qui annulerait ceci.",
  adminEditDefaultEmpty:
    "Une valeur par défaut vide ne peut pas être écrite : l'API l'ignore et signale tout de même un succès. Supprimez plutôt la définition si c'est ce que vous voulez.",
  adminDeleteDefinition: 'Supprimer le paramètre',
  adminRowMenuLabel: 'Autres actions pour {configKey}',
  adminDeleting: 'Suppression…',
  adminDeleteFailed: 'Échec de la suppression',
  adminDeletePermanently: 'Supprimer définitivement',
  adminDeleteDeprecatedTitle: 'Supprimer cette définition ?',
  adminDeleteDeprecatedBody:
    "{configKey} a été retirée des valeurs par défaut d'usine. La supprimer retire la définition de tout l'environnement.",
  adminDeleteDeprecatedConsequence:
    "Toute substitution de cette clé par une organisation est supprimée avec elle. Rien dans l'application ne lit cette clé.",
  adminDeleteUnrecognizedTitle:
    "Cette clé ne figure pas dans nos valeurs par défaut d'usine",
  adminDeleteUnrecognizedBody:
    "{configKey} est enregistrée dans cet environnement, mais n'apparaît ni dans les valeurs par défaut d'usine ni dans la liste des définitions retirées.",
  adminDeleteUnrecognizedChoice:
    "Cela signifie généralement l'une de deux choses, qui appellent des actions opposées. Soit quelqu'un l'a enregistrée à la main et elle est réellement obsolète, auquel cas la supprimer est le bon geste — soit nous avons oublié de l'ajouter aux valeurs par défaut d'usine, auquel cas la supprimer brise une fonctionnalité active et la prochaine analyse ne vous signalera pas sa disparition.",
  adminDeleteTypeHint: 'Saisissez exactement :',
  adminDeleteTypeToConfirm:
    'Saisissez la clé pour confirmer que vous avez vérifié',
  adminMutationRootOrgHint:
    "Ces mutations exigent normalement l'organisation racine de l'instance.",
});

export default {
  [LOCALES.FRENCH]: {
    ...getCommonMessages(),
  },
  [LOCALES.REDACT_FRENCH]: {
    ...getCommonMessages(),
    // Override common values
    caseActions: "Demande d'actions",
    casesCreated: 'Demandes créées',
    casesApproved: 'Demandes approuvées',
    casesReopened: 'Réouverture des demandes',
    caseName: 'Nom de la demande',
    caseNameRequired: 'Nom de la demande requis',
    caseDeleted: 'Demande supprimée',
    caseArchived: 'Demande archivée',
    caseDashboard: 'Tableau de bord des demandes',
    archiveCase: "Demande d'archives",
    deleteCase: 'Demande de suppression',
    deleteCaseConfirmDialog:
      'Êtes-vous sûr de vouloir supprimer cette demande ? Une fois supprimée, la demande ne peut être récupérée.',
    archiveCaseContent:
      "Êtes-vous sûr de vouloir archiver cette demande ? Une fois archivée, la demande ne sera plus visible sur le tableau de bord, sauf si l'option 'Afficher tout' est activée.",
    low: 'Faible',
    high: 'Haute',
    toneVolume: 'Volume de tonalité',
  },
};
